var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g3, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _g4, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnackImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_893)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.4502 18.36C35.4502 21.8488 34.4106 25.2593 32.463 28.1602C30.5153 31.0611 27.747 33.3221 24.5082 34.6572C21.2693 35.9923 17.7054 36.3417 14.2671 35.661C10.8288 34.9804 7.67046 33.3003 5.19156 30.8333C2.71267 28.3663 1.02452 25.2232 0.34059 21.8014C-0.343336 18.3795 0.00768 14.8327 1.34925 11.6094C2.69082 8.38615 4.96269 5.63115 7.87756 3.69285C10.7924 1.75454 14.2194 0.719971 17.7251 0.719971C22.4261 0.719971 26.9345 2.57847 30.2586 5.88661C33.5827 9.19475 35.4502 13.6816 35.4502 18.36Z",
    fill: "url(#paint0_radial_41_893)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4702 34.8912C28.1516 34.8912 35.9999 27.0805 35.9999 17.4456C35.9999 7.81066 28.1516 0 18.4702 0C8.78876 0 0.94043 7.81066 0.94043 17.4456C0.94043 27.0805 8.78876 34.8912 18.4702 34.8912Z",
    fill: "url(#paint1_linear_41_893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1608 17.4456C35.1608 20.7308 34.1819 23.9423 32.348 26.6738C30.514 29.4054 27.9073 31.5344 24.8575 32.7916C21.8077 34.0488 18.4518 34.3778 15.2142 33.7368C11.9765 33.0959 9.00254 31.5139 6.66833 29.1909C4.33412 26.8679 2.7445 23.9082 2.1005 20.6861C1.45649 17.464 1.78702 14.1242 3.05028 11.0891C4.31355 8.05393 6.45281 5.45974 9.19755 3.63456C11.9423 1.80939 15.1692 0.835205 18.4703 0.835205C20.6623 0.834733 22.8329 1.26405 24.8581 2.09863C26.8833 2.93322 28.7234 4.15671 30.2733 5.69922C31.8233 7.24174 33.0527 9.07304 33.8913 11.0885C34.7299 13.104 35.1613 15.2642 35.1608 17.4456Z",
    fill: "url(#paint2_linear_41_893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7455 17.4456C29.7455 19.6649 29.0842 21.8344 27.8452 23.6797C26.6063 25.525 24.8453 26.9633 22.785 27.8126C20.7247 28.6619 18.4576 28.8841 16.2704 28.4512C14.0832 28.0182 12.0742 26.9495 10.4973 25.3802C8.92041 23.8108 7.84654 21.8114 7.41148 19.6347C6.97642 17.458 7.19971 15.2018 8.05311 13.1514C8.90651 11.101 10.3517 9.34848 12.2059 8.11548C14.0601 6.88248 16.2401 6.22437 18.4702 6.22437C19.9508 6.22437 21.417 6.51461 22.785 7.07853C24.153 7.64245 25.396 8.46899 26.443 9.51098C27.49 10.553 28.3206 11.79 28.8872 13.1514C29.4538 14.5128 29.7455 15.972 29.7455 17.4456Z",
    fill: "url(#paint3_linear_41_893)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.939 17.4456C28.939 19.5035 28.326 21.5153 27.1773 23.2266C26.0287 24.9379 24.396 26.2719 22.4858 27.0599C20.5755 27.8479 18.4733 28.0547 16.445 27.654C14.4167 27.2533 12.5533 26.2631 11.0903 24.8087C9.62732 23.3542 8.63045 21.5008 8.22571 19.4826C7.82097 17.4644 8.02652 15.3722 8.81638 13.4702C9.60625 11.5683 10.945 9.94211 12.6633 8.79721C14.3817 7.65232 16.4025 7.04011 18.4704 7.03797C19.8446 7.03655 21.2057 7.3047 22.4757 7.8271C23.7458 8.34949 24.8999 9.11589 25.8722 10.0825C26.8444 11.049 27.6157 12.1968 28.1419 13.4603C28.6682 14.7237 28.939 16.0779 28.939 17.4456Z",
    fill: "url(#paint4_linear_41_893)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93296 16.9848C7.93131 15.1528 8.38126 13.3484 9.24339 11.7297C10.1055 10.111 11.3535 8.72746 12.8779 7.70044C11.5771 8.45868 10.4423 9.46882 9.54065 10.6711C8.63897 11.8734 7.98869 13.2434 7.62827 14.7001C7.26785 16.1569 7.20462 17.6708 7.44231 19.1522C7.67999 20.6337 8.21378 22.0527 9.01209 23.3253C9.8104 24.5979 10.857 25.6983 12.0901 26.5614C13.3231 27.4245 14.7176 28.0327 16.1909 28.3501C17.6643 28.6675 19.1866 28.6877 20.668 28.4095C22.1493 28.1312 23.5595 27.5601 24.8152 26.73C23.1001 27.7096 21.1562 28.2229 19.1787 28.2184C17.2013 28.2139 15.2598 27.6917 13.5492 26.7043C11.8387 25.7168 10.4192 24.299 9.43342 22.5929C8.44762 20.8869 7.93015 18.9528 7.93296 16.9848Z",
    fill: "#FBFCF6"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7456 17.4456C29.7458 15.3085 29.1328 13.2159 27.9787 11.4137C26.8246 9.61151 25.1773 8.1748 23.2307 7.27253C21.2841 6.37027 19.1191 6.03997 16.9903 6.32048C14.8615 6.601 12.8574 7.48066 11.2139 8.85601C13.584 7.16024 16.5225 6.44533 19.4115 6.86164C22.3004 7.27795 24.9145 8.79304 26.7039 11.0882C28.4934 13.3834 29.3186 16.2798 29.0062 19.1681C28.6937 22.0565 27.2679 24.7117 25.0286 26.5752C26.4888 25.5375 27.6788 24.1676 28.4993 22.5795C29.3198 20.9915 29.7471 19.2313 29.7456 17.4456Z",
    fill: "#C7C8C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8377 18.9108C1.86895 19.3302 1.92573 19.7474 2.00771 20.16C2.22088 21.2567 2.54196 22.3298 2.96632 23.364C3.24794 24.0539 3.57419 24.7249 3.943 25.3728C4.35489 26.0957 4.81787 26.7887 5.32845 27.4464C5.8709 28.151 6.46842 28.8118 7.11543 29.4228C7.78108 30.0551 8.49593 30.6341 9.25329 31.1544C10.0104 31.6741 10.8145 32.1224 11.6552 32.4936C12.4724 32.8533 13.3197 33.1412 14.1874 33.354C14.9937 33.5567 15.8132 33.7035 16.6399 33.7932C17.3852 33.8658 18.1341 33.8934 18.8827 33.876C20.005 33.8494 21.1231 33.729 22.2252 33.516C22.6267 33.4368 22.9486 33.3684 23.1476 33.3144L23.4731 33.2316L23.1512 33.336C22.9414 33.3936 22.6339 33.48 22.236 33.57C21.8381 33.66 21.3498 33.75 20.7891 33.8328C18.5708 34.1569 16.3114 34.0678 14.1259 33.57C13.252 33.3584 12.3986 33.0704 11.5756 32.7096C10.7186 32.3383 9.89871 31.8875 9.12669 31.3632C8.35708 30.8324 7.6313 30.2413 6.95627 29.5956C5.14402 27.8671 3.73827 25.7613 2.83971 23.4288C2.43516 22.3821 2.14177 21.2962 1.96431 20.1888C1.89919 19.7856 1.87025 19.4688 1.85217 19.2528C1.83408 19.0368 1.8377 18.9108 1.8377 18.9108Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9932 0.842407C19.9932 0.842407 20.1089 0.842407 20.326 0.860407C20.543 0.878407 20.8649 0.907207 21.2665 0.972007C22.3792 1.14862 23.4704 1.44061 24.5221 1.84321C26.0166 2.41517 27.4231 3.19316 28.7002 4.15441C30.1658 5.26072 31.4486 6.58837 32.502 8.08921C33.03 8.85745 33.4842 9.67345 33.8585 10.5264C34.2222 11.3504 34.5127 12.2044 34.7267 13.0788C35.2269 15.2526 35.3164 17.5 34.9908 19.7064C34.9112 20.268 34.8171 20.754 34.7267 21.1464C34.6363 21.5388 34.5531 21.8664 34.4916 22.0572C34.4301 22.248 34.3939 22.3776 34.3939 22.3776C34.3939 22.3776 34.4228 22.266 34.4807 22.0536C34.5386 21.8412 34.6037 21.5316 34.6797 21.1356C34.8933 20.0388 35.0143 18.9261 35.0414 17.8092C35.0608 17.0642 35.033 16.3187 34.9582 15.5772C34.8757 14.7508 34.733 13.9315 34.5313 13.1256C34.3185 12.2619 34.0292 11.4186 33.6668 10.6056C33.2952 9.76938 32.8446 8.97019 32.3211 8.21881C31.2848 6.73312 30.0215 5.41766 28.5772 4.32001C27.9161 3.81508 27.2211 3.35562 26.4972 2.94481C25.8457 2.57629 25.1701 2.25156 24.4751 1.97281C23.4361 1.55002 22.3577 1.23047 21.2556 1.01881C20.839 0.933475 20.4173 0.874556 19.9932 0.842407Z",
    fill: "#D8D9D4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M15.9166 22.1184C16.4592 21.4452 15.8985 20.8656 16.2458 20.3184C16.8101 19.5588 16.2458 18.8784 16.4881 18.4536C16.7305 18.0288 17.0416 17.8956 16.915 17.2692C16.8535 16.9488 16.7124 16.632 16.915 16.3152C17.1175 15.9984 17.3635 15.732 17.2948 15.3216C17.2261 14.9112 17.0705 14.5836 17.2948 14.2416C17.5191 13.8996 17.993 13.4064 17.6565 12.7548C17.3201 12.1032 16.9331 12.5856 16.6618 12.4668C16.2783 12.3084 16.2024 12.0744 15.6055 12.2616C15.0086 12.4488 14.882 12.4884 14.5854 12.1752C14.2888 11.862 13.9921 11.4768 13.464 11.8548C12.9359 12.2328 12.7405 12.1284 12.2558 11.8548C11.8941 11.6352 11.5323 11.4408 11.1887 11.574C10.9809 11.6657 10.7547 11.7085 10.5276 11.6991C10.3005 11.6898 10.0786 11.6285 9.8792 11.52C9.43858 11.2388 8.90901 11.1298 8.39247 11.214C7.93306 11.3112 7.47728 11.6532 6.87679 11.1024C6.27631 10.5516 5.61795 11.1024 5.40453 10.9692C5.1911 10.836 4.57977 10.1736 4.06248 10.6092C3.5452 11.0448 4.01908 11.8152 4.01908 11.8152C4.30123 12.5892 3.92141 12.6 3.70075 13.0032C3.48009 13.4064 3.53797 13.3992 3.59223 13.9212C3.64649 14.4432 3.37519 14.616 3.05324 14.9112C2.7313 15.2064 2.8579 15.5448 2.93025 15.948C3.0026 16.3512 2.81088 16.4556 2.60107 16.9488C2.39126 17.442 2.3985 17.5536 2.57937 18.1152C2.76023 18.6768 2.51064 18.72 2.33339 19.08C2.1992 19.4251 2.18268 19.8046 2.28636 20.16C2.35147 20.6028 2.09102 20.7864 1.92462 21.0528C1.84421 21.1895 1.79915 21.344 1.79346 21.5023C1.78778 21.6606 1.82166 21.8179 1.89207 21.96C2.00782 22.1868 1.92462 22.4388 1.71843 22.788C1.51224 23.1372 1.50863 23.688 2.14166 23.6412C2.7747 23.5944 2.82173 23.6124 3.41136 24.0012C4.00099 24.39 4.19994 24.1596 4.82575 24.048C5.45155 23.9364 5.29239 24.084 5.87478 24.3756C6.45718 24.6672 6.71763 24.4368 7.15895 24.2604C7.60027 24.084 7.88242 24.138 8.49014 24.534C9.09785 24.93 9.23531 24.7356 9.76345 24.534C10.2916 24.3324 10.4507 24.3504 10.9355 24.7824C11.134 24.9571 11.3816 25.067 11.6449 25.0973C11.9082 25.1275 12.1744 25.0767 12.4077 24.9516C12.8274 24.7536 12.9576 24.5196 13.4712 25.0128C13.9849 25.506 15.4608 25.4304 15.3306 24.7716C15.2003 24.1128 15.5585 24.0516 15.7249 23.796C16.2241 22.9608 15.4355 22.7232 15.9166 22.1184Z",
    fill: "url(#paint5_radial_41_893)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9346 21.7692C16.4664 21.114 15.9346 20.5488 16.2602 20.0016C16.81 19.26 16.2602 18.6084 16.4917 18.1836C16.7232 17.7588 17.0343 17.6436 16.9113 17.0316C16.8498 16.722 16.7124 16.4088 16.9113 16.1064C17.1103 15.804 17.378 15.5556 17.3128 15.1524C17.2477 14.7492 17.0922 14.4324 17.3128 14.1012C17.5335 13.77 17.9893 13.2912 17.6565 12.6612C17.3237 12.0312 16.9692 12.4992 16.6943 12.384C16.3325 12.2292 16.2421 12.0024 15.6633 12.1824C15.0846 12.3624 14.9399 12.4056 14.6686 12.0996C14.3973 11.7936 14.0934 11.4192 13.5833 11.7864C13.0733 12.1536 12.8599 12.0528 12.4041 11.7864C12.0604 11.574 11.7132 11.3832 11.3695 11.5164C11.166 11.6053 10.9446 11.6464 10.7225 11.6364C10.5004 11.6264 10.2836 11.5656 10.089 11.4588C9.65878 11.1885 9.14478 11.0823 8.64203 11.16C8.19709 11.2572 7.75216 11.592 7.16614 11.0592C6.58013 10.5264 5.94348 11.0592 5.7192 10.9224C5.49492 10.7856 4.91253 10.1484 4.40971 10.584C3.9069 11.0196 4.3663 11.7612 4.3663 11.7612C4.64122 12.51 4.27225 12.5244 4.05521 12.9132C3.83817 13.302 3.89966 13.302 3.95393 13.8096C4.00819 14.3172 3.74774 14.4576 3.43664 14.76C3.12555 15.0624 3.24492 15.3756 3.31727 15.768C3.38962 16.1604 3.1979 16.2648 2.99171 16.74C2.78552 17.2152 2.79999 17.3304 2.99171 17.8812C3.18343 18.432 2.89404 18.4572 2.73487 18.8172C2.59572 19.1614 2.58038 19.543 2.69147 19.8972C2.75296 20.3292 2.49613 20.5056 2.32973 20.7684C2.26119 20.9009 2.22544 21.0478 2.22544 21.1968C2.22544 21.3458 2.26119 21.4927 2.32973 21.6252C2.43825 21.8484 2.35867 22.0896 2.15971 22.4316C1.96076 22.7736 1.93182 23.2956 2.5323 23.2524C3.13278 23.2092 3.19428 23.2236 3.76944 23.5908C4.3446 23.958 4.53632 23.742 5.14765 23.634C5.75899 23.526 5.59983 23.67 6.16413 23.9508C6.72844 24.2316 6.98528 24.012 7.41936 23.8356C7.85344 23.6592 8.11389 23.7204 8.71076 24.1056C9.30762 24.4908 9.43423 24.3036 9.95151 24.1056C10.4688 23.9076 10.6207 23.9292 11.0946 24.3468C11.2888 24.5202 11.5323 24.6293 11.7916 24.659C12.0508 24.6886 12.3129 24.6374 12.5415 24.5124C12.9467 24.3216 13.0733 24.0948 13.5761 24.5736C14.0789 25.0524 15.5114 24.9768 15.3848 24.336C15.2582 23.6952 15.6091 23.6484 15.7682 23.3856C16.253 22.59 15.4861 22.3596 15.9346 21.7692Z",
    fill: "url(#paint6_radial_41_893)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M6.87294 15.6852C6.89444 15.8972 6.85244 16.1108 6.75223 16.2991C6.65203 16.4874 6.49809 16.642 6.30979 16.7434C6.1215 16.8448 5.90726 16.8886 5.69405 16.8691C5.48084 16.8496 5.27818 16.7678 5.11158 16.634C4.94498 16.5001 4.82188 16.3203 4.75778 16.1169C4.69368 15.9136 4.69145 15.696 4.75135 15.4914C4.81126 15.2869 4.93064 15.1045 5.09445 14.9673C5.25827 14.8301 5.45921 14.7442 5.67198 14.7204C5.81463 14.7044 5.95905 14.7168 6.09686 14.7568C6.23468 14.7967 6.36316 14.8635 6.47486 14.9533C6.58656 15.043 6.67926 15.1539 6.74759 15.2795C6.81592 15.4052 6.85853 15.543 6.87294 15.6852Z",
    fill: "url(#paint7_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M7.43714 13.1976C7.46008 13.4097 7.41937 13.6239 7.32015 13.813C7.22093 14.0021 7.06764 14.1578 6.87964 14.2603C6.69163 14.3628 6.47732 14.4076 6.26375 14.3891C6.05018 14.3705 5.84692 14.2894 5.67961 14.156C5.51231 14.0226 5.38845 13.8429 5.32367 13.6395C5.2589 13.4361 5.2561 13.2182 5.31564 13.0132C5.37517 12.8083 5.49438 12.6254 5.65821 12.4878C5.82204 12.3502 6.02315 12.264 6.23617 12.24C6.37828 12.224 6.52215 12.2361 6.65954 12.2756C6.79692 12.3152 6.9251 12.3813 7.0367 12.4703C7.14831 12.5593 7.24114 12.6694 7.30986 12.7942C7.37858 12.919 7.42184 13.0561 7.43714 13.1976Z",
    fill: "url(#paint8_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M6.23976 18.3168C6.26198 18.5288 6.22063 18.7427 6.12091 18.9314C6.0212 19.1201 5.86758 19.2752 5.67943 19.3772C5.49128 19.4792 5.27701 19.5235 5.06361 19.5045C4.85022 19.4854 4.64726 19.404 4.48031 19.2704C4.31335 19.1367 4.18988 18.9569 4.12544 18.7536C4.061 18.5502 4.05849 18.3325 4.11821 18.1277C4.17794 17.9229 4.29723 17.7403 4.46105 17.6029C4.62487 17.4655 4.8259 17.3794 5.0388 17.3556C5.18117 17.3396 5.32532 17.3518 5.46292 17.3916C5.60052 17.4313 5.72885 17.4978 5.8405 17.5872C5.95215 17.6765 6.04492 17.787 6.11345 17.9122C6.18197 18.0374 6.2249 18.1749 6.23976 18.3168Z",
    fill: "url(#paint9_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M5.71925 21.24C5.74147 21.452 5.70012 21.6659 5.6004 21.8546C5.50069 22.0433 5.34708 22.1985 5.15892 22.3004C4.97077 22.4024 4.7565 22.4467 4.54311 22.4277C4.32971 22.4087 4.12675 22.3272 3.9598 22.1936C3.79285 22.06 3.66937 21.8801 3.60493 21.6768C3.5405 21.4734 3.53798 21.2557 3.59771 21.0509C3.65743 20.8461 3.77672 20.6636 3.94054 20.5261C4.10437 20.3887 4.30539 20.3027 4.51829 20.2788C4.66067 20.2628 4.80481 20.275 4.94241 20.3148C5.08001 20.3545 5.20834 20.421 5.31999 20.5104C5.43165 20.5997 5.52441 20.7102 5.59294 20.8354C5.66147 20.9607 5.7044 21.0982 5.71925 21.24Z",
    fill: "url(#paint10_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M10.1284 16.11C10.1507 16.322 10.1093 16.5359 10.0096 16.7246C9.90987 16.9133 9.75626 17.0685 9.5681 17.1704C9.37995 17.2724 9.16568 17.3167 8.95229 17.2977C8.73889 17.2786 8.53593 17.1972 8.36898 17.0636C8.20203 16.9299 8.07855 16.7501 8.01411 16.5468C7.94968 16.3434 7.94716 16.1257 8.00689 15.9209C8.06661 15.7161 8.1859 15.5335 8.34972 15.3961C8.51355 15.2587 8.71457 15.1727 8.92747 15.1488C9.06985 15.1328 9.21399 15.145 9.35159 15.1848C9.48919 15.2245 9.61752 15.291 9.72917 15.3804C9.84083 15.4697 9.93359 15.5802 10.0021 15.7054C10.0706 15.8307 10.1136 15.9681 10.1284 16.11Z",
    fill: "url(#paint11_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M10.6895 13.7088C10.7117 13.9209 10.6703 14.1348 10.5706 14.3235C10.4709 14.5122 10.3173 14.6673 10.1291 14.7693C9.94099 14.8713 9.72671 14.9156 9.51332 14.8965C9.29993 14.8775 9.09697 14.7961 8.93001 14.6624C8.76306 14.5288 8.63959 14.349 8.57515 14.1457C8.51071 13.9423 8.5082 13.7245 8.56792 13.5198C8.62764 13.315 8.74693 13.1324 8.91076 12.995C9.07458 12.8576 9.27561 12.7715 9.4885 12.7476C9.63088 12.7317 9.77503 12.7439 9.91263 12.7837C10.0502 12.8234 10.1786 12.8899 10.2902 12.9792C10.4019 13.0686 10.4946 13.1791 10.5632 13.3043C10.6317 13.4295 10.6746 13.567 10.6895 13.7088Z",
    fill: "url(#paint12_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M9.40525 18.72C9.42756 18.9323 9.3862 19.1463 9.28639 19.3352C9.18658 19.524 9.03279 19.6792 8.84443 19.7812C8.65607 19.8831 8.44159 19.9273 8.22805 19.908C8.0145 19.8888 7.81148 19.807 7.64459 19.673C7.4777 19.5391 7.35443 19.3589 7.29034 19.1553C7.22625 18.9516 7.2242 18.7337 7.28447 18.5289C7.34473 18.3241 7.4646 18.1417 7.62895 18.0046C7.7933 17.8676 7.99476 17.7821 8.2079 17.7588C8.35 17.7434 8.49376 17.756 8.63094 17.796C8.76812 17.836 8.89602 17.9025 9.00727 17.9918C9.11853 18.0812 9.21096 18.1915 9.27926 18.3164C9.34756 18.4414 9.39037 18.5786 9.40525 18.72Z",
    fill: "url(#paint13_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M8.9966 21.6216C9.01882 21.8336 8.97746 22.0475 8.87775 22.2362C8.77803 22.4249 8.62442 22.5801 8.43627 22.682C8.24812 22.784 8.03384 22.8283 7.82045 22.8093C7.60706 22.7902 7.4041 22.7088 7.23714 22.5752C7.07019 22.4415 6.94671 22.2617 6.88228 22.0584C6.81784 21.855 6.81533 21.6373 6.87505 21.4325C6.93477 21.2277 7.05406 21.0451 7.21789 20.9077C7.38171 20.7703 7.58274 20.6843 7.79563 20.6604C7.93801 20.6444 8.08216 20.6566 8.21976 20.6964C8.35736 20.7361 8.48568 20.8026 8.59734 20.892C8.70899 20.9813 8.80176 21.0918 8.87028 21.217C8.93881 21.3423 8.98174 21.4797 8.9966 21.6216Z",
    fill: "url(#paint14_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M12.9575 16.4736C12.9798 16.6857 12.9384 16.8996 12.8387 17.0883C12.739 17.277 12.5854 17.4321 12.3972 17.5341C12.2091 17.6361 11.9948 17.6803 11.7814 17.6613C11.568 17.6423 11.365 17.5608 11.1981 17.4272C11.0311 17.2936 10.9077 17.1138 10.8432 16.9104C10.7788 16.7071 10.7763 16.4893 10.836 16.2846C10.8957 16.0798 11.015 15.8972 11.1788 15.7598C11.3426 15.6224 11.5437 15.5363 11.7566 15.5124C11.8989 15.4964 12.0431 15.5087 12.1807 15.5484C12.3183 15.5882 12.4466 15.6546 12.5583 15.744C12.6699 15.8334 12.7627 15.9439 12.8312 16.0691C12.8997 16.1943 12.9427 16.3318 12.9575 16.4736Z",
    fill: "url(#paint15_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M13.5144 14.0399C13.5341 14.2512 13.4908 14.4635 13.39 14.6504C13.2892 14.8373 13.1353 14.9905 12.9476 15.0909C12.7598 15.1913 12.5465 15.2345 12.3343 15.215C12.122 15.1955 11.9202 15.1143 11.7541 14.9814C11.5879 14.8486 11.4648 14.6699 11.4 14.4679C11.3352 14.2658 11.3316 14.0492 11.3898 13.8451C11.4479 13.641 11.5651 13.4585 11.7268 13.3203C11.8885 13.1821 12.0875 13.0943 12.299 13.0679C12.4433 13.05 12.5898 13.061 12.7297 13.1005C12.8697 13.14 13.0002 13.207 13.1136 13.2977C13.227 13.3884 13.3209 13.5008 13.3898 13.6283C13.4586 13.7558 13.501 13.8958 13.5144 14.0399Z",
    fill: "url(#paint16_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M12.2304 19.1592C12.2519 19.3712 12.2099 19.5848 12.1097 19.7731C12.0094 19.9614 11.8555 20.116 11.6672 20.2174C11.4789 20.3188 11.2647 20.3626 11.0515 20.3431C10.8383 20.3236 10.6356 20.2418 10.469 20.108C10.3024 19.9741 10.1793 19.7943 10.1152 19.5909C10.0511 19.3876 10.0489 19.17 10.1088 18.9654C10.1687 18.7609 10.2881 18.5785 10.4519 18.4413C10.6157 18.3041 10.8166 18.2182 11.0294 18.1944C11.1721 18.1784 11.3165 18.1908 11.4543 18.2308C11.5921 18.2707 11.7206 18.3375 11.8323 18.4273C11.944 18.517 12.0367 18.6279 12.105 18.7535C12.1733 18.8792 12.216 19.017 12.2304 19.1592Z",
    fill: "url(#paint17_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M11.7564 21.9888C11.7786 22.2008 11.7372 22.4147 11.6375 22.6034C11.5378 22.7921 11.3842 22.9472 11.196 23.0492C11.0079 23.1512 10.7936 23.1955 10.5802 23.1764C10.3668 23.1574 10.1639 23.076 9.99691 22.9424C9.82996 22.8087 9.70648 22.6289 9.64204 22.4256C9.57761 22.2222 9.57509 22.0045 9.63481 21.7997C9.69454 21.5949 9.81383 21.4123 9.97765 21.2749C10.1415 21.1375 10.3425 21.0514 10.5554 21.0276C10.6978 21.0116 10.8419 21.0238 10.9795 21.0636C11.1171 21.1033 11.2455 21.1698 11.3571 21.2591C11.4688 21.3485 11.5615 21.459 11.63 21.5842C11.6986 21.7094 11.7415 21.8469 11.7564 21.9888Z",
    fill: "url(#paint18_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M15.6668 16.8048C15.6884 17.0169 15.6464 17.2307 15.5461 17.4192C15.4458 17.6076 15.2917 17.7623 15.1032 17.8637C14.9147 17.9651 14.7003 18.0087 14.4869 17.989C14.2735 17.9693 14.0708 17.8872 13.9043 17.753C13.7377 17.6188 13.6149 17.4385 13.5511 17.2349C13.4873 17.0314 13.4856 16.8135 13.546 16.6089C13.6065 16.4044 13.7264 16.2222 13.8908 16.0853C14.0551 15.9485 14.2565 15.8631 14.4695 15.84C14.6119 15.8245 14.7559 15.8373 14.8933 15.8775C15.0307 15.9177 15.1587 15.9846 15.27 16.0743C15.3814 16.1639 15.4737 16.2747 15.5418 16.4C15.6099 16.5254 15.6524 16.663 15.6668 16.8048Z",
    fill: "url(#paint19_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M16.1879 14.4C16.2094 14.612 16.1674 14.8256 16.0672 15.0139C15.967 15.2022 15.813 15.3568 15.6247 15.4583C15.4364 15.5597 15.2222 15.6034 15.009 15.5839C14.7958 15.5645 14.5931 15.4827 14.4265 15.3488C14.2599 15.215 14.1368 15.0351 14.0727 14.8318C14.0086 14.6285 14.0064 14.4108 14.0663 14.2063C14.1262 14.0017 14.2456 13.8193 14.4094 13.6821C14.5732 13.5449 14.7742 13.459 14.9869 13.4352C15.1296 13.4193 15.274 13.4316 15.4118 13.4716C15.5496 13.5116 15.6781 13.5784 15.7898 13.6681C15.9015 13.7578 15.9942 13.8687 16.0625 13.9944C16.1309 14.12 16.1735 14.2579 16.1879 14.4Z",
    fill: "url(#paint20_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M14.9399 19.4904C14.9623 19.7028 14.9209 19.917 14.821 20.106C14.7211 20.295 14.5671 20.4503 14.3786 20.5522C14.19 20.6542 13.9753 20.6982 13.7616 20.6787C13.5479 20.6592 13.3448 20.5771 13.178 20.4428C13.0112 20.3085 12.8881 20.1279 12.8244 19.924C12.7606 19.7201 12.7591 19.502 12.8199 19.2972C12.8807 19.0924 13.0011 18.9101 13.166 18.7734C13.3309 18.6367 13.5328 18.5517 13.7461 18.5292C13.888 18.5142 14.0313 18.5272 14.1681 18.5675C14.3049 18.6077 14.4323 18.6743 14.5432 18.7636C14.6541 18.8529 14.7462 18.963 14.8142 19.0877C14.8823 19.2124 14.925 19.3493 14.9399 19.4904Z",
    fill: "url(#paint21_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M14.4697 22.1976C14.493 22.4103 14.4523 22.6252 14.3526 22.8149C14.253 23.0045 14.099 23.1605 13.9102 23.2629C13.7214 23.3653 13.5062 23.4096 13.292 23.3901C13.0779 23.3706 12.8744 23.2883 12.7073 23.1535C12.5403 23.0186 12.4173 22.8375 12.3539 22.633C12.2905 22.4284 12.2896 22.2098 12.3513 22.0048C12.413 21.7997 12.5345 21.6176 12.7004 21.4814C12.8664 21.3452 13.0692 21.2612 13.2832 21.24C13.5679 21.2117 13.8522 21.2965 14.0744 21.4758C14.2966 21.6551 14.4387 21.9145 14.4697 22.1976Z",
    fill: "url(#paint22_radial_41_893)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70683 13.3488C6.71287 13.4074 6.70134 13.4665 6.6737 13.5187C6.64607 13.5708 6.60355 13.6136 6.55151 13.6418C6.49946 13.6699 6.44022 13.6821 6.38122 13.6768C6.32223 13.6716 6.26613 13.649 6.21997 13.6121C6.17382 13.5751 6.13968 13.5254 6.12184 13.4692C6.10401 13.413 6.10328 13.3528 6.11975 13.2962C6.13622 13.2395 6.16915 13.189 6.21439 13.151C6.25964 13.113 6.31518 13.0891 6.37403 13.0824C6.4135 13.0779 6.45347 13.0812 6.49163 13.0922C6.52979 13.1032 6.56538 13.1216 6.59633 13.1464C6.62728 13.1712 6.65299 13.2018 6.67196 13.2366C6.69093 13.2713 6.70278 13.3095 6.70683 13.3488Z",
    fill: "url(#paint23_radial_41_893)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1496 15.768C6.15773 15.8471 6.13419 15.9263 6.08409 15.9883C6.03398 16.0503 5.96134 16.0901 5.88191 16.0992C5.82205 16.106 5.7615 16.095 5.70795 16.0675C5.65441 16.04 5.61029 15.9972 5.5812 15.9447C5.55212 15.8922 5.53938 15.8323 5.5446 15.7725C5.54983 15.7128 5.57278 15.6559 5.61055 15.6092C5.64831 15.5625 5.69918 15.528 5.7567 15.5101C5.81421 15.4922 5.87577 15.4918 5.93354 15.5088C5.99132 15.5258 6.04271 15.5595 6.08118 15.6057C6.11965 15.6518 6.14347 15.7083 6.1496 15.768Z",
    fill: "url(#paint24_radial_41_893)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45877 18.36C5.46563 18.4196 5.45454 18.4798 5.4269 18.5331C5.39927 18.5864 5.35633 18.6303 5.30356 18.6593C5.25079 18.6882 5.19057 18.7009 5.13054 18.6957C5.07051 18.6905 5.01339 18.6677 4.96644 18.6301C4.91949 18.5925 4.88482 18.5419 4.86685 18.4846C4.84888 18.4274 4.84842 18.3661 4.86552 18.3086C4.88262 18.2511 4.91651 18.2 4.96289 18.1617C5.00926 18.1234 5.06603 18.0997 5.12597 18.0936C5.2055 18.0855 5.28504 18.1089 5.34733 18.1588C5.40963 18.2087 5.44967 18.281 5.45877 18.36Z",
    fill: "url(#paint25_radial_41_893)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95918 21.24C4.96345 21.2792 4.95992 21.3189 4.94878 21.3568C4.93764 21.3946 4.91912 21.43 4.89426 21.4607C4.84406 21.5228 4.77112 21.5626 4.69149 21.5712C4.61186 21.5797 4.53207 21.5565 4.46965 21.5065C4.40724 21.4566 4.36733 21.384 4.35869 21.3048C4.35006 21.2255 4.37341 21.1461 4.42361 21.084C4.47381 21.0219 4.54675 20.9821 4.62638 20.9736C4.70601 20.965 4.78581 20.9882 4.84822 21.0382C4.91063 21.0881 4.95054 21.1607 4.95918 21.24Z",
    fill: "url(#paint26_radial_41_893)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92265 13.7772C9.92869 13.8359 9.91716 13.895 9.88953 13.9471C9.86189 13.9993 9.81937 14.0421 9.76733 14.0703C9.71528 14.0984 9.65604 14.1106 9.59704 14.1053C9.53805 14.1 9.48195 14.0775 9.43579 14.0405C9.38964 14.0036 9.3555 13.9539 9.33766 13.8977C9.31983 13.8415 9.3191 13.7813 9.33557 13.7246C9.35204 13.668 9.38497 13.6175 9.43021 13.5795C9.47546 13.5414 9.531 13.5175 9.58985 13.5108C9.62932 13.5064 9.66929 13.5097 9.70745 13.5207C9.74561 13.5317 9.7812 13.5501 9.81215 13.5749C9.8431 13.5997 9.86881 13.6303 9.88778 13.665C9.90675 13.6998 9.9186 13.7379 9.92265 13.7772Z",
    fill: "url(#paint27_radial_41_893)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36894 16.2C9.37498 16.2586 9.36345 16.3177 9.33581 16.3699C9.30818 16.422 9.26566 16.4648 9.21362 16.493C9.16157 16.5211 9.10233 16.5333 9.04333 16.528C8.98434 16.5228 8.92824 16.5002 8.88208 16.4633C8.83593 16.4263 8.80179 16.3766 8.78395 16.3204C8.76612 16.2642 8.76539 16.204 8.78186 16.1474C8.79833 16.0907 8.83126 16.0402 8.8765 16.0022C8.92175 15.9641 8.97729 15.9403 9.03614 15.9336C9.07561 15.9291 9.11558 15.9324 9.15374 15.9434C9.1919 15.9544 9.22748 15.9728 9.25844 15.9976C9.28939 16.0224 9.3151 16.053 9.33407 16.0878C9.35303 16.1225 9.36489 16.1606 9.36894 16.2Z",
    fill: "url(#paint28_radial_41_893)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68144 18.7848C8.68748 18.8435 8.67595 18.9026 8.64831 18.9547C8.62068 19.0068 8.57816 19.0497 8.52612 19.0778C8.47407 19.106 8.41483 19.1182 8.35583 19.1129C8.29684 19.1076 8.24074 19.0851 8.19458 19.0481C8.14843 19.0112 8.11429 18.9615 8.09645 18.9052C8.07862 18.849 8.07789 18.7888 8.09436 18.7322C8.11083 18.6756 8.14376 18.6251 8.189 18.587C8.23425 18.549 8.28979 18.5251 8.34864 18.5184C8.38811 18.5139 8.42808 18.5173 8.46624 18.5283C8.5044 18.5393 8.53999 18.5577 8.57094 18.5825C8.60189 18.6072 8.6276 18.6379 8.64657 18.6726C8.66554 18.7073 8.67739 18.7455 8.68144 18.7848Z",
    fill: "url(#paint29_radial_41_893)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17167 21.654C8.17771 21.7126 8.16619 21.7717 8.13855 21.8238C8.11091 21.876 8.06839 21.9188 8.01635 21.947C7.96431 21.9751 7.90506 21.9873 7.84607 21.982C7.78707 21.9767 7.73097 21.9542 7.68482 21.9172C7.63866 21.8803 7.60452 21.8306 7.58669 21.7744C7.56885 21.7182 7.56812 21.658 7.58459 21.6013C7.60106 21.5447 7.63399 21.4942 7.67924 21.4562C7.72448 21.4181 7.78003 21.3943 7.83887 21.3876C7.87834 21.3831 7.91831 21.3864 7.95647 21.3974C7.99463 21.4084 8.03022 21.4268 8.06117 21.4516C8.09213 21.4764 8.11783 21.507 8.1368 21.5418C8.15577 21.5765 8.16762 21.6146 8.17167 21.654Z",
    fill: "url(#paint30_radial_41_893)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7259 14.148C12.7319 14.2066 12.7204 14.2657 12.6927 14.3179C12.6651 14.37 12.6226 14.4128 12.5706 14.441C12.5185 14.4691 12.4593 14.4813 12.4003 14.476C12.3413 14.4707 12.2852 14.4482 12.239 14.4113C12.1929 14.3743 12.1587 14.3246 12.1409 14.2684C12.1231 14.2122 12.1223 14.152 12.1388 14.0954C12.1553 14.0387 12.1882 13.9882 12.2334 13.9502C12.2787 13.9121 12.3342 13.8883 12.3931 13.8816C12.4726 13.8735 12.5521 13.8969 12.6144 13.9468C12.6767 13.9966 12.7168 14.0689 12.7259 14.148Z",
    fill: "url(#paint31_radial_41_893)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1726 16.56C12.1787 16.6186 12.1672 16.6777 12.1395 16.7298C12.1119 16.782 12.0694 16.8248 12.0173 16.853C11.9653 16.8811 11.906 16.8933 11.847 16.888C11.7881 16.8827 11.7319 16.8602 11.6858 16.8233C11.6396 16.7863 11.6055 16.7366 11.5877 16.6804C11.5698 16.6242 11.5691 16.564 11.5856 16.5074C11.602 16.4507 11.635 16.4002 11.6802 16.3622C11.7255 16.3241 11.781 16.3003 11.8399 16.2936C11.8793 16.2891 11.9193 16.2924 11.9574 16.3034C11.9956 16.3144 12.0312 16.3328 12.0622 16.3576C12.0931 16.3824 12.1188 16.413 12.1378 16.4478C12.1567 16.4825 12.1686 16.5206 12.1726 16.56Z",
    fill: "url(#paint32_radial_41_893)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4744 19.1555C11.4804 19.2142 11.4689 19.2733 11.4413 19.3254C11.4136 19.3776 11.3711 19.4204 11.3191 19.4485C11.267 19.4767 11.2078 19.4889 11.1488 19.4836C11.0898 19.4783 11.0337 19.4558 10.9876 19.4188C10.9414 19.3819 10.9073 19.3322 10.8894 19.276C10.8716 19.2198 10.8709 19.1596 10.8873 19.1029C10.9038 19.0463 10.9367 18.9958 10.982 18.9578C11.0272 18.9197 11.0828 18.8958 11.1416 18.8891C11.1811 18.8847 11.221 18.888 11.2592 18.899C11.2974 18.91 11.333 18.9284 11.3639 18.9532C11.3949 18.978 11.4206 19.0086 11.4395 19.0433C11.4585 19.0781 11.4704 19.1162 11.4744 19.1555Z",
    fill: "url(#paint33_radial_41_893)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9749 22.0248C10.9809 22.0834 10.9694 22.1426 10.9418 22.1947C10.9141 22.2468 10.8716 22.2897 10.8196 22.3178C10.7675 22.346 10.7083 22.3582 10.6493 22.3529C10.5903 22.3476 10.5342 22.325 10.488 22.2881C10.4419 22.2512 10.4077 22.2014 10.3899 22.1452C10.3721 22.089 10.3713 22.0288 10.3878 21.9722C10.4043 21.9156 10.4372 21.8651 10.4825 21.827C10.5277 21.789 10.5832 21.7651 10.6421 21.7584C10.6816 21.7539 10.7215 21.7573 10.7597 21.7683C10.7979 21.7792 10.8334 21.7977 10.8644 21.8224C10.8954 21.8472 10.9211 21.8779 10.94 21.9126C10.959 21.9473 10.9708 21.9855 10.9749 22.0248Z",
    fill: "url(#paint34_radial_41_893)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4208 14.4647C15.4248 14.504 15.421 14.5436 15.4097 14.5814C15.3983 14.6192 15.3796 14.6544 15.3546 14.685C15.3296 14.7156 15.2987 14.741 15.2638 14.7597C15.229 14.7784 15.1907 14.7901 15.1513 14.7941C15.1118 14.7982 15.072 14.7944 15.034 14.7831C14.9961 14.7718 14.9607 14.7532 14.93 14.7283C14.8992 14.7034 14.8737 14.6727 14.8549 14.638C14.8361 14.6032 14.8243 14.5652 14.8203 14.5259C14.8158 14.4869 14.8192 14.4473 14.8303 14.4095C14.8414 14.3718 14.8599 14.3366 14.8848 14.3061C14.9098 14.2756 14.9406 14.2503 14.9755 14.2318C15.0104 14.2133 15.0486 14.2019 15.088 14.1983C15.1274 14.1939 15.1674 14.1972 15.2056 14.2082C15.2437 14.2192 15.2793 14.2376 15.3103 14.2624C15.3412 14.2872 15.3669 14.3178 15.3859 14.3525C15.4049 14.3873 15.4167 14.4254 15.4208 14.4647Z",
    fill: "url(#paint35_radial_41_893)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8675 16.8804C14.8735 16.939 14.862 16.9981 14.8344 17.0503C14.8067 17.1024 14.7642 17.1453 14.7122 17.1734C14.6601 17.2015 14.6009 17.2137 14.5419 17.2085C14.4829 17.2032 14.4268 17.1806 14.3806 17.1437C14.3345 17.1067 14.3003 17.057 14.2825 17.0008C14.2647 16.9446 14.2639 16.8844 14.2804 16.8278C14.2969 16.7712 14.3298 16.7207 14.375 16.6826C14.4203 16.6446 14.4758 16.6207 14.5347 16.614C14.5741 16.6095 14.6141 16.6128 14.6523 16.6238C14.6904 16.6348 14.726 16.6533 14.757 16.678C14.7879 16.7028 14.8136 16.7335 14.8326 16.7682C14.8516 16.8029 14.8634 16.8411 14.8675 16.8804Z",
    fill: "url(#paint36_radial_41_893)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1728 19.4688C14.1773 19.5084 14.1738 19.5484 14.1625 19.5866C14.1513 19.6248 14.1324 19.6604 14.1072 19.6912C14.0819 19.7221 14.0507 19.7476 14.0154 19.7663C13.98 19.7849 13.9413 19.7964 13.9015 19.8C13.8426 19.8053 13.7835 19.7932 13.7316 19.7652C13.6796 19.7372 13.6371 19.6946 13.6093 19.6426C13.5816 19.5907 13.5699 19.5318 13.5757 19.4733C13.5814 19.4147 13.6044 19.3592 13.6417 19.3136C13.6791 19.268 13.7291 19.2344 13.7856 19.217C13.842 19.1996 13.9024 19.1991 13.9591 19.2157C14.0158 19.2323 14.0663 19.2651 14.1043 19.3102C14.1423 19.3552 14.1661 19.4104 14.1728 19.4688Z",
    fill: "url(#paint37_radial_41_893)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6735 22.3416C13.6788 22.4002 13.6666 22.459 13.6385 22.5108C13.6104 22.5625 13.5675 22.6048 13.5154 22.6324C13.4632 22.66 13.404 22.6717 13.3452 22.6659C13.2864 22.6602 13.2306 22.6373 13.1847 22.6001C13.1389 22.563 13.1052 22.5132 13.0877 22.457C13.0702 22.4009 13.0697 22.3408 13.0864 22.2844C13.103 22.2279 13.136 22.1777 13.1813 22.1398C13.2265 22.102 13.282 22.0783 13.3407 22.0716C13.4206 22.0646 13.5001 22.0888 13.5623 22.1393C13.6245 22.1897 13.6644 22.2623 13.6735 22.3416Z",
    fill: "url(#paint38_radial_41_893)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.00314 11.5524C7.00314 11.5524 7.79534 11.9916 8.22581 11.7612C8.76841 11.4768 8.81182 11.358 9.43039 11.8044C10.049 12.2508 9.7668 12.7908 9.28208 13.0716C8.79735 13.3524 8.70692 14.6124 8.24028 15.0588C7.77364 15.5052 6.88738 14.6988 7.15507 14.094C7.28045 13.8375 7.32068 13.5479 7.26997 13.2671C7.21926 12.9863 7.08022 12.7287 6.87291 12.5316C6.51118 12.1752 6.40266 11.2752 7.00314 11.5524Z",
    fill: "url(#paint39_radial_41_893)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.91755 17.3411C3.91755 17.3411 4.09841 15.8435 5.00275 16.3727C5.9071 16.9019 6.15669 16.4735 6.78611 16.4627C7.41554 16.4519 8.5116 16.5635 8.95653 16.9703C9.40147 17.3771 9.35444 18.0107 8.5948 17.9747C7.83515 17.9387 8.1173 18.3095 7.78812 18.9719C7.45894 19.6343 6.30501 20.0519 6.2001 19.0835C6.0952 18.1151 6.08796 17.5067 5.62494 17.4419C5.16192 17.3771 4.93402 17.4023 4.59761 18.0071C4.26119 18.6119 3.64986 18.0503 3.91755 17.3411Z",
    fill: "url(#paint40_radial_41_893)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.48824 14.5188C9.48824 14.5188 10.483 14.1588 11.1088 14.5188C11.7346 14.8788 12.1253 14.7708 12.2664 15.2388C12.4074 15.7068 12.1181 15.93 11.7274 16.0596C11.6216 16.0838 11.5247 16.1367 11.4474 16.2125C11.3701 16.2883 11.3154 16.384 11.2896 16.4889C11.2637 16.5938 11.2676 16.7037 11.3008 16.8065C11.334 16.9094 11.3953 17.001 11.4778 17.0712C11.8829 17.5212 11.438 18.0396 11.0292 18.1836C10.6205 18.3276 9.64017 17.9856 9.82465 17.2044C10.0091 16.4232 9.89338 15.7644 9.59314 15.48C9.2929 15.1956 9.10118 14.6952 9.48824 14.5188Z",
    fill: "url(#paint41_radial_41_893)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.1234 20.9376C11.3387 21.0072 11.5214 21.1519 11.6378 21.3452C11.7542 21.5384 11.7963 21.7671 11.7564 21.9888C11.6406 22.8132 11.5502 22.572 10.9787 23.0688C10.4071 23.5656 11.2427 23.7888 11.4634 24.0768C11.6841 24.3648 12.7693 24.0012 12.8199 23.31C12.8705 22.6188 12.7548 22.1328 13.0189 21.6684C13.2829 21.204 13.6121 20.7936 13.0767 20.4768C12.5414 20.16 10.3312 19.962 11.1234 20.9376Z",
    fill: "url(#paint42_radial_41_893)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.0587 12.438C13.0587 12.438 13.7207 11.6928 14.2235 12.186C14.7263 12.6792 14.5346 12.6648 15.5149 12.4956C16.4952 12.3264 16.6001 12.798 16.5025 13.2588C16.4048 13.7196 15.8007 13.9428 15.3594 13.734C14.918 13.5252 14.3574 13.7124 13.9124 13.7916C13.4675 13.8708 13.453 13.4316 13.3083 13.2768C13.1636 13.122 12.9104 12.6 13.0587 12.438Z",
    fill: "url(#paint43_radial_41_893)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.9431 13.4064C5.9235 13.412 5.90652 13.4243 5.89514 13.4412C5.88376 13.458 5.8787 13.4783 5.88086 13.4985C5.88302 13.5187 5.89225 13.5375 5.90694 13.5516C5.92163 13.5657 5.94083 13.5742 5.96118 13.5756C5.98078 13.5699 5.99776 13.5576 6.00914 13.5408C6.02053 13.5239 6.02558 13.5036 6.02342 13.4834C6.02126 13.4632 6.01203 13.4444 5.99734 13.4304C5.98265 13.4163 5.96345 13.4078 5.9431 13.4064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.18207 17.2368C8.17114 17.238 8.16056 17.2413 8.15092 17.2466C8.14128 17.2518 8.13277 17.2589 8.12589 17.2674C8.11198 17.2846 8.10551 17.3067 8.10791 17.3286C8.11031 17.3506 8.12138 17.3707 8.13868 17.3845C8.15597 17.3984 8.17809 17.4048 8.20015 17.4024C8.22222 17.4 8.24243 17.389 8.25634 17.3718C8.27024 17.3546 8.27671 17.3326 8.27431 17.3106C8.27191 17.2887 8.26085 17.2685 8.24355 17.2547C8.22625 17.2409 8.20413 17.2344 8.18207 17.2368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.8357 15.5916C11.8161 15.5972 11.7991 15.6095 11.7877 15.6264C11.7763 15.6432 11.7713 15.6635 11.7734 15.6837C11.7756 15.7039 11.7848 15.7227 11.7995 15.7368C11.8142 15.7509 11.8334 15.7593 11.8538 15.7608C11.8734 15.7551 11.8903 15.7428 11.9017 15.7259C11.9131 15.7091 11.9182 15.6888 11.916 15.6686C11.9138 15.6484 11.9046 15.6296 11.8899 15.6155C11.8752 15.6014 11.856 15.593 11.8357 15.5916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.2109 20.2319C15.2 20.2331 15.1894 20.2364 15.1797 20.2417C15.1701 20.2469 15.1616 20.254 15.1547 20.2625C15.1408 20.2798 15.1343 20.3018 15.1367 20.3237C15.1391 20.3457 15.1502 20.3658 15.1675 20.3796C15.1848 20.3935 15.2069 20.3999 15.229 20.3975C15.251 20.3951 15.2712 20.3841 15.2851 20.3669C15.2991 20.3497 15.3055 20.3277 15.3031 20.3057C15.3007 20.2838 15.2897 20.2637 15.2724 20.2498C15.2551 20.236 15.2329 20.2295 15.2109 20.2319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.86009 20.538C5.84049 20.5436 5.82351 20.5559 5.81213 20.5728C5.80075 20.5896 5.79569 20.6099 5.79785 20.6301C5.80001 20.6503 5.80924 20.6691 5.82393 20.6832C5.83862 20.6973 5.85782 20.7058 5.87818 20.7072C5.89778 20.7015 5.91476 20.6892 5.92614 20.6724C5.93752 20.6555 5.94257 20.6352 5.94041 20.615C5.93826 20.5948 5.92902 20.576 5.91433 20.5619C5.89965 20.5479 5.88044 20.5394 5.86009 20.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.92181 12.6864C7.89975 12.6888 7.87954 12.6998 7.86563 12.717C7.85173 12.7342 7.84526 12.7562 7.84766 12.7782C7.85006 12.8002 7.86112 12.8203 7.87842 12.8341C7.89572 12.848 7.91784 12.8544 7.9399 12.852C7.96197 12.8496 7.98218 12.8386 7.99608 12.8214C8.00999 12.8042 8.01646 12.7822 8.01406 12.7602C8.01166 12.7382 8.00059 12.7181 7.98329 12.7043C7.966 12.6904 7.94388 12.684 7.92181 12.6864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66917 15.12C9.64957 15.1256 9.63259 15.138 9.62121 15.1548C9.60983 15.1717 9.60477 15.192 9.60693 15.2121C9.60909 15.2323 9.61832 15.2511 9.63301 15.2652C9.6477 15.2793 9.66691 15.2878 9.68726 15.2892C9.70686 15.2836 9.72384 15.2712 9.73522 15.2544C9.7466 15.2375 9.75165 15.2172 9.7495 15.197C9.74734 15.1769 9.73811 15.1581 9.72342 15.144C9.70873 15.1299 9.68952 15.1214 9.66917 15.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26304 17.6868C5.24349 17.6908 5.22593 17.7014 5.21333 17.7168C5.20073 17.7322 5.19385 17.7515 5.19385 17.7714C5.19385 17.7912 5.20073 17.8105 5.21333 17.8259C5.22593 17.8413 5.24349 17.8519 5.26304 17.856C5.28258 17.8519 5.30014 17.8413 5.31274 17.8259C5.32534 17.8105 5.33222 17.7912 5.33222 17.7714C5.33222 17.7515 5.32534 17.7322 5.31274 17.7168C5.30014 17.7014 5.28258 17.6908 5.26304 17.6868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.289 19.5336C9.27808 19.5348 9.26749 19.5381 9.25785 19.5433C9.24821 19.5486 9.23971 19.5557 9.23282 19.5642C9.21891 19.5814 9.21245 19.6034 9.21485 19.6254C9.21724 19.6473 9.22831 19.6674 9.24561 19.6813C9.26291 19.6951 9.28502 19.7016 9.30709 19.6992C9.32915 19.6968 9.34936 19.6858 9.36327 19.6686C9.37718 19.6513 9.38364 19.6293 9.38124 19.6074C9.37885 19.5854 9.36778 19.5653 9.35048 19.5515C9.33318 19.5376 9.31107 19.5312 9.289 19.5336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0477 17.3124C13.0282 17.3164 13.0106 17.327 12.998 17.3424C12.9854 17.3578 12.9785 17.3771 12.9785 17.397C12.9785 17.4168 12.9854 17.4361 12.998 17.4515C13.0106 17.4669 13.0282 17.4775 13.0477 17.4816C13.0673 17.4775 13.0848 17.4669 13.0974 17.4515C13.11 17.4361 13.1169 17.4168 13.1169 17.397C13.1169 17.3771 13.11 17.3578 13.0974 17.3424C13.0848 17.327 13.0673 17.3164 13.0477 17.3124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8656 16.9524C15.846 16.9564 15.8285 16.967 15.8159 16.9825C15.8033 16.9979 15.7964 17.0171 15.7964 17.037C15.7964 17.0569 15.8033 17.0761 15.8159 17.0915C15.8285 17.1069 15.846 17.1176 15.8656 17.1216C15.8851 17.1176 15.9027 17.1069 15.9153 17.0915C15.9279 17.0761 15.9348 17.0569 15.9348 17.037C15.9348 17.0171 15.9279 16.9979 15.9153 16.9825C15.9027 16.967 15.8851 16.9564 15.8656 16.9524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8889 22.176C14.8693 22.1817 14.8523 22.194 14.8409 22.2108C14.8296 22.2277 14.8245 22.248 14.8267 22.2682C14.8288 22.2884 14.838 22.3071 14.8527 22.3212C14.8674 22.3353 14.8866 22.3438 14.907 22.3452C14.9266 22.3396 14.9436 22.3273 14.9549 22.3104C14.9663 22.2936 14.9714 22.2733 14.9692 22.2531C14.9671 22.2329 14.9578 22.2141 14.9431 22.2C14.9285 22.1859 14.9092 22.1774 14.8889 22.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7274 20.4083C11.7078 20.4124 11.6903 20.423 11.6777 20.4384C11.6651 20.4538 11.6582 20.4731 11.6582 20.4929C11.6582 20.5128 11.6651 20.5321 11.6777 20.5475C11.6903 20.5629 11.7078 20.5735 11.7274 20.5775C11.7469 20.5735 11.7645 20.5629 11.7771 20.5475C11.7897 20.5321 11.7966 20.5128 11.7966 20.4929C11.7966 20.4731 11.7897 20.4538 11.7771 20.4384C11.7645 20.423 11.7469 20.4124 11.7274 20.4083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89573 19.314C3.87613 19.3196 3.85915 19.3319 3.84777 19.3488C3.83639 19.3656 3.83134 19.3859 3.8335 19.4061C3.83565 19.4263 3.84489 19.4451 3.85957 19.4592C3.87426 19.4733 3.89347 19.4818 3.91382 19.4832C3.93342 19.4775 3.9504 19.4652 3.96178 19.4484C3.97316 19.4315 3.97822 19.4112 3.97606 19.391C3.9739 19.3708 3.96467 19.352 3.94998 19.338C3.93529 19.3239 3.91609 19.3154 3.89573 19.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06431 18.5184C7.04476 18.5225 7.0272 18.5331 7.0146 18.5485C7.002 18.5639 6.99512 18.5832 6.99512 18.603C6.99512 18.6229 7.002 18.6422 7.0146 18.6576C7.0272 18.673 7.04476 18.6836 7.06431 18.6876C7.08385 18.6836 7.10141 18.673 7.11401 18.6576C7.12661 18.6422 7.13349 18.6229 7.13349 18.603C7.13349 18.5832 7.12661 18.5639 7.11401 18.5485C7.10141 18.5331 7.08385 18.5225 7.06431 18.5184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08275 22.896C7.06315 22.9016 7.04617 22.914 7.03478 22.9308C7.0234 22.9477 7.01835 22.968 7.02051 22.9881C7.02266 23.0083 7.0319 23.0271 7.04659 23.0412C7.06127 23.0553 7.08048 23.0638 7.10083 23.0652C7.12043 23.0596 7.13741 23.0472 7.14879 23.0304C7.16017 23.0135 7.16523 22.9932 7.16307 22.9731C7.16091 22.9529 7.15168 22.9341 7.13699 22.92C7.1223 22.9059 7.1031 22.8974 7.08275 22.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2991 12.3876C12.2795 12.3932 12.2625 12.4055 12.2511 12.4224C12.2397 12.4392 12.2347 12.4595 12.2368 12.4797C12.239 12.4999 12.2482 12.5187 12.2629 12.5328C12.2776 12.5469 12.2968 12.5554 12.3171 12.5568C12.3367 12.5511 12.3537 12.5388 12.3651 12.522C12.3765 12.5051 12.3815 12.4848 12.3794 12.4646C12.3772 12.4444 12.368 12.4256 12.3533 12.4116C12.3386 12.3975 12.3194 12.389 12.2991 12.3876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35248 20.88C8.34155 20.8812 8.33097 20.8845 8.32133 20.8898C8.31169 20.895 8.30318 20.9021 8.2963 20.9106C8.28239 20.9278 8.27592 20.9498 8.27832 20.9718C8.28072 20.9938 8.29179 21.0139 8.30909 21.0277C8.32638 21.0416 8.3485 21.048 8.37056 21.0456C8.39263 21.0432 8.41284 21.0322 8.42675 21.015C8.44065 20.9978 8.44712 20.9758 8.44472 20.9538C8.44232 20.9318 8.43126 20.9117 8.41396 20.8979C8.39666 20.8841 8.37454 20.8776 8.35248 20.88Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0501 16.5996C14.0347 16.5996 14.02 16.6057 14.0091 16.6165C13.9983 16.6273 13.9922 16.6419 13.9922 16.6572C13.9922 16.6725 13.9983 16.6871 14.0091 16.6979C14.02 16.7087 14.0347 16.7148 14.0501 16.7148C14.0654 16.7148 14.0801 16.7087 14.091 16.6979C14.1018 16.6871 14.1079 16.6725 14.1079 16.6572C14.1079 16.6419 14.1018 16.6273 14.091 16.6165C14.0801 16.6057 14.0654 16.5996 14.0501 16.5996Z",
    fill: "#B55113"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30157 16.9524C6.28824 16.9557 6.2764 16.9633 6.26794 16.9741C6.25948 16.9849 6.25488 16.9981 6.25488 17.0118C6.25488 17.0255 6.25948 17.0387 6.26794 17.0495C6.2764 17.0603 6.28824 17.0679 6.30157 17.0712C6.3149 17.0679 6.32674 17.0603 6.3352 17.0495C6.34367 17.0387 6.34826 17.0255 6.34826 17.0118C6.34826 16.9981 6.34367 16.9849 6.3352 16.9741C6.32674 16.9633 6.3149 16.9557 6.30157 16.9524Z",
    fill: "#B55113"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33424 13.5396C6.31889 13.5396 6.30417 13.5456 6.29332 13.5564C6.28246 13.5672 6.27637 13.5819 6.27637 13.5972C6.27637 13.6124 6.28246 13.6271 6.29332 13.6379C6.30417 13.6487 6.31889 13.6548 6.33424 13.6548C6.3496 13.6548 6.36432 13.6487 6.37517 13.6379C6.38602 13.6271 6.39212 13.6124 6.39212 13.5972C6.39212 13.5819 6.38602 13.5672 6.37517 13.5564C6.36432 13.5456 6.3496 13.5396 6.33424 13.5396Z",
    fill: "#B55113"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96364 18.8316C8.94829 18.8316 8.93357 18.8377 8.92271 18.8485C8.91186 18.8593 8.90576 18.874 8.90576 18.8892C8.90576 18.9045 8.91186 18.9192 8.92271 18.93C8.93357 18.9408 8.94829 18.9468 8.96364 18.9468C9.04322 18.936 9.04322 18.8208 8.96364 18.8316Z",
    fill: "#B55113"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15997 18.774C4.14664 18.7773 4.1348 18.785 4.12634 18.7957C4.11788 18.8065 4.11328 18.8198 4.11328 18.8334C4.11328 18.8471 4.11788 18.8604 4.12634 18.8712C4.1348 18.8819 4.14664 18.8896 4.15997 18.8928C4.1733 18.8896 4.18514 18.8819 4.1936 18.8712C4.20206 18.8604 4.20666 18.8471 4.20666 18.8334C4.20666 18.8198 4.20206 18.8065 4.1936 18.7957C4.18514 18.785 4.1733 18.7773 4.15997 18.774Z",
    fill: "#B55113"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7747 20.0088C11.7593 20.0088 11.7446 20.0149 11.7337 20.0257C11.7229 20.0365 11.7168 20.0511 11.7168 20.0664C11.7168 20.0817 11.7229 20.0963 11.7337 20.1071C11.7446 20.1179 11.7593 20.124 11.7747 20.124C11.79 20.124 11.8047 20.1179 11.8156 20.1071C11.8265 20.0963 11.8326 20.0817 11.8326 20.0664C11.8326 20.0511 11.8265 20.0365 11.8156 20.0257C11.8047 20.0149 11.79 20.0088 11.7747 20.0088Z",
    fill: "#B55113"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9734 22.374C11.9581 22.374 11.9433 22.3801 11.9325 22.3909C11.9216 22.4017 11.9155 22.4163 11.9155 22.4316C11.9155 22.4469 11.9216 22.4616 11.9325 22.4724C11.9433 22.4832 11.9581 22.4892 11.9734 22.4892C11.9888 22.4892 12.0035 22.4832 12.0143 22.4724C12.0252 22.4616 12.0313 22.4469 12.0313 22.4316C12.0313 22.4163 12.0252 22.4017 12.0143 22.3909C12.0035 22.3801 11.9888 22.374 11.9734 22.374Z",
    fill: "#B55113"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4319 22.9104C6.41655 22.9104 6.40183 22.9165 6.39098 22.9273C6.38012 22.9381 6.37402 22.9527 6.37402 22.968C6.37402 22.9833 6.38012 22.9979 6.39098 23.0087C6.40183 23.0195 6.41655 23.0256 6.4319 23.0256C6.44725 23.0256 6.46197 23.0195 6.47283 23.0087C6.48368 22.9979 6.48978 22.9833 6.48978 22.968C6.48978 22.9527 6.48368 22.9381 6.47283 22.9273C6.46197 22.9165 6.44725 22.9104 6.4319 22.9104Z",
    fill: "#B55113"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10426 19.5984C7.08891 19.5984 7.07419 19.6045 7.06334 19.6153C7.05248 19.6261 7.04639 19.6407 7.04639 19.656C7.04639 19.6713 7.05248 19.6859 7.06334 19.6967C7.07419 19.7075 7.08891 19.7136 7.10426 19.7136C7.11961 19.7136 7.13434 19.7075 7.14519 19.6967C7.15604 19.6859 7.16214 19.6713 7.16214 19.656C7.16214 19.6407 7.15604 19.6261 7.14519 19.6153C7.13434 19.6045 7.11961 19.5984 7.10426 19.5984Z",
    fill: "#B55113"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.679 22.014C12.6657 22.0173 12.6538 22.025 12.6454 22.0357C12.6369 22.0465 12.6323 22.0598 12.6323 22.0734C12.6323 22.0871 12.6369 22.1004 12.6454 22.1111C12.6538 22.1219 12.6657 22.1295 12.679 22.1328C12.6923 22.1295 12.7042 22.1219 12.7126 22.1111C12.7211 22.1004 12.7257 22.0871 12.7257 22.0734C12.7257 22.0598 12.7211 22.0465 12.7126 22.0357C12.7042 22.025 12.6923 22.0173 12.679 22.014Z",
    fill: "#B55113"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0442 23.2848C13.0289 23.2848 13.0141 23.2909 13.0033 23.3017C12.9924 23.3125 12.9863 23.3272 12.9863 23.3424C12.9863 23.3577 12.9924 23.3724 13.0033 23.3832C13.0141 23.394 13.0289 23.4 13.0442 23.4C13.131 23.4 13.1202 23.274 13.0442 23.2848Z",
    fill: "#B55113"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58327 14.238C4.56792 14.238 4.5532 14.2441 4.54234 14.2549C4.53149 14.2657 4.52539 14.2804 4.52539 14.2956C4.52539 14.3109 4.53149 14.3256 4.54234 14.3364C4.5532 14.3472 4.56792 14.3532 4.58327 14.3532C4.59862 14.3532 4.61334 14.3472 4.62419 14.3364C4.63505 14.3256 4.64115 14.3109 4.64115 14.2956C4.64115 14.2804 4.63505 14.2657 4.62419 14.2549C4.61334 14.2441 4.59862 14.238 4.58327 14.238Z",
    fill: "#B55113"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8314 15.2424C14.818 15.2457 14.8062 15.2534 14.7977 15.2641C14.7893 15.2749 14.7847 15.2882 14.7847 15.3018C14.7847 15.3155 14.7893 15.3288 14.7977 15.3395C14.8062 15.3503 14.818 15.3579 14.8314 15.3612C14.8447 15.3579 14.8565 15.3503 14.865 15.3395C14.8735 15.3288 14.878 15.3155 14.878 15.3018C14.878 15.2882 14.8735 15.2749 14.865 15.2641C14.8565 15.2534 14.8447 15.2457 14.8314 15.2424Z",
    fill: "#B55113"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3674 14.3029C10.3521 14.3029 10.3374 14.3089 10.3265 14.3197C10.3157 14.3305 10.3096 14.3452 10.3096 14.3605C10.3096 14.3757 10.3157 14.3904 10.3265 14.4012C10.3374 14.412 10.3521 14.4181 10.3674 14.4181C10.3828 14.4181 10.3975 14.412 10.4084 14.4012C10.4192 14.3904 10.4253 14.3757 10.4253 14.3605C10.4253 14.3452 10.4192 14.3305 10.4084 14.3197C10.3975 14.3089 10.3828 14.3029 10.3674 14.3029Z",
    fill: "#B55113"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0468 18.7884C16.1518 20.0628 15.3234 19.2708 15.6851 20.556C16.0468 21.8412 15.0159 21.3804 15.2583 22.4496C15.5006 23.5188 14.6505 23.238 14.712 23.8284C14.7735 24.4188 14.2924 24.3108 14.0103 24.03C13.7281 23.7492 13.3664 23.67 12.7406 23.9976C12.1148 24.3252 11.366 23.9328 10.8523 23.58C10.3386 23.2272 9.42707 24.1092 9.01469 23.8068C8.79277 23.6428 8.53261 23.5376 8.25863 23.5011C7.98466 23.4646 7.70585 23.4979 7.44838 23.598C6.74661 23.7996 6.36317 23.778 5.84227 23.3316C5.32137 22.8852 4.5581 23.6916 4.18551 23.4468C3.81293 23.202 3.70802 22.806 3.03881 23.04C2.71523 23.1341 2.37038 23.1265 2.05127 23.0184C2.10915 23.1696 2.26108 23.2776 2.54685 23.256C3.16542 23.2128 3.20883 23.2272 3.78399 23.5944C4.35915 23.9616 4.55087 23.7456 5.1622 23.6376C5.77354 23.5296 5.61437 23.6736 6.17868 23.9544C6.74299 24.2352 6.99982 24.0156 7.43391 23.8392C7.86799 23.6628 8.12844 23.724 8.72531 24.1092C9.32217 24.4944 9.44878 24.3072 9.96606 24.1092C10.4833 23.9112 10.6353 23.9328 11.1091 24.3504C11.3033 24.5239 11.5469 24.633 11.8061 24.6626C12.0653 24.6923 12.3274 24.6411 12.5561 24.516C12.9612 24.3252 13.0878 24.0984 13.5907 24.5772C14.0935 25.056 15.5259 24.9804 15.3993 24.3396C15.2727 23.6988 15.6236 23.652 15.7828 23.3892C16.2675 22.6008 15.5006 22.3704 15.9492 21.78C16.4809 21.1248 15.9492 20.5596 16.2747 20.0124C16.8246 19.2708 16.2747 18.6192 16.5063 18.1944C16.7378 17.7696 16.9765 17.6868 16.9512 17.244C16.6401 17.7876 15.9636 17.7804 16.0468 18.7884Z",
    fill: "url(#paint44_radial_41_893)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.4493 16.92C32.0606 16.3116 31.5651 15.6744 31.9738 15.1488C32.6177 14.454 32.1185 13.7268 32.4115 13.32C32.7045 12.9132 33.0265 12.8268 32.9686 12.186C32.936 11.862 32.8348 11.5308 33.0554 11.2392C33.2761 10.9476 33.5944 10.728 33.5691 10.3104C33.5438 9.89277 33.4208 9.55437 33.6921 9.23037C33.9634 8.90637 34.477 8.47437 34.2057 7.79037C33.9344 7.10637 33.5221 7.54917 33.2508 7.40157C32.889 7.20357 32.8348 6.96237 32.2198 7.08477C31.6049 7.20717 31.4602 7.22877 31.2142 6.89037C30.9682 6.55196 30.7005 6.13437 30.129 6.45117C29.5574 6.76797 29.3693 6.64557 28.928 6.30357C28.5988 6.04797 28.266 5.81397 27.8971 5.91477C27.6797 5.98216 27.4498 5.99936 27.2248 5.96505C26.9997 5.93074 26.7855 5.84583 26.5984 5.71677C26.1893 5.39135 25.6746 5.22617 25.1515 5.25237C24.6848 5.30277 24.1965 5.59437 23.6575 4.98597C23.1185 4.37757 22.4059 4.86357 22.2106 4.69437C22.0152 4.52517 21.4871 3.81237 20.9083 4.20477C20.3295 4.59717 20.7383 5.39997 20.7383 5.39997C20.9336 6.19557 20.5574 6.16677 20.2934 6.54477C20.0293 6.92277 20.0908 6.92277 20.0908 7.44477C20.0908 7.96677 19.7978 8.11437 19.4469 8.37717C19.096 8.63997 19.1828 8.98557 19.2154 9.39237C19.2479 9.79917 19.0381 9.88557 18.7777 10.35C18.5172 10.8144 18.5136 10.9332 18.6294 11.5128C18.7451 12.0924 18.4991 12.1068 18.2676 12.456C18.0951 12.7882 18.0391 13.1684 18.1085 13.536C18.1085 13.9824 17.8444 14.1372 17.6418 14.3856C17.5532 14.5113 17.4964 14.6565 17.4762 14.8088C17.4561 14.9612 17.4732 15.116 17.5261 15.2604C17.6129 15.498 17.5008 15.7392 17.262 16.0632C17.0233 16.3872 16.9545 16.938 17.5912 16.9596C18.2278 16.9812 18.2676 17.0028 18.8175 17.4384C19.3673 17.874 19.5807 17.676 20.2174 17.6328C20.854 17.5896 20.6768 17.7192 21.223 18.0684C21.7692 18.4176 22.055 18.2232 22.5144 18.09C22.9738 17.9568 23.2379 18.0468 23.8058 18.504C24.3737 18.9612 24.5293 18.7884 25.0755 18.6336C25.6217 18.4788 25.7773 18.5256 26.215 18.9936C26.3934 19.1892 26.6278 19.3255 26.8866 19.3841C27.1454 19.4427 27.4161 19.4207 27.6619 19.3212C28.0996 19.17 28.2516 18.9612 28.7146 19.4976C29.1776 20.034 30.6462 20.1204 30.5884 19.4508C30.5305 18.7812 30.8922 18.7704 31.084 18.522C31.6844 17.8092 30.9248 17.4888 31.4493 16.92Z",
    fill: "url(#paint45_radial_41_893)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5254 16.5924C32.1222 15.9984 31.6375 15.3792 32.0354 14.868C32.6612 14.1912 32.1765 13.4856 32.4622 13.0896C32.748 12.6936 33.0591 12.6072 33.0012 11.9844C32.9723 11.6712 32.871 11.3472 33.0881 11.0628C33.3051 10.7784 33.6126 10.566 33.5872 10.1592C33.5619 9.75243 33.4462 9.43923 33.7102 9.11523C33.9743 8.79123 34.4735 8.39523 34.2094 7.71483C33.9454 7.03443 33.5402 7.47723 33.2798 7.33323C32.918 7.13883 32.871 6.90843 32.2778 7.02363C31.6845 7.13883 31.5543 7.16763 31.2975 6.83643C31.0406 6.50523 30.7983 6.11643 30.2484 6.40803C29.6986 6.69963 29.5069 6.59883 29.08 6.26763C28.7581 6.01923 28.4361 5.79243 28.078 5.88603C27.8664 5.95304 27.6422 5.97068 27.4226 5.9376C27.2031 5.90451 26.9941 5.82158 26.8119 5.69523C26.4141 5.37884 25.9134 5.21872 25.4048 5.24523C24.949 5.29203 24.4751 5.57643 23.9578 4.98243C23.4405 4.38843 22.7424 4.86363 22.5507 4.69803C22.359 4.53243 21.8272 3.84483 21.2846 4.22283C20.742 4.60083 21.1073 5.40003 21.1073 5.40003C21.2991 6.17763 20.9301 6.14883 20.6733 6.51603C20.4164 6.88323 20.4743 6.87603 20.4743 7.39083C20.4743 7.90563 20.1922 8.02803 19.8521 8.28003C19.5121 8.53203 19.5953 8.87403 19.6242 9.26643C19.6532 9.65883 19.4542 9.74883 19.1974 10.1988C18.9405 10.6488 18.9405 10.7676 19.0563 11.3328C19.1721 11.898 18.9261 11.9124 18.7163 12.2508C18.5432 12.579 18.4871 12.956 18.5571 13.32C18.5571 13.7556 18.3003 13.9068 18.1049 14.148C18.0187 14.2701 17.9633 14.411 17.9431 14.5588C17.923 14.7066 17.9388 14.8571 17.9892 14.9976C18.076 15.2316 17.9892 15.462 17.736 15.7824C17.4827 16.1028 17.4357 16.6284 18.0543 16.65C18.6729 16.6716 18.7163 16.6932 19.248 17.118C19.7798 17.5428 19.9932 17.3484 20.6118 17.3052C21.2303 17.262 21.0567 17.3916 21.5921 17.73C22.1274 18.0684 22.3987 17.8776 22.8473 17.7516C23.2958 17.6256 23.5491 17.7084 24.1061 18.1548C24.6632 18.6012 24.8079 18.432 25.3397 18.2808C25.8714 18.1296 26.0233 18.1764 26.4466 18.6408C26.6198 18.8314 26.8477 18.9644 27.0994 19.0217C27.3511 19.079 27.6145 19.0579 27.8537 18.9612C28.2806 18.8136 28.4289 18.6012 28.8774 19.1304C29.326 19.6596 30.7585 19.7388 30.6861 19.0872C30.6138 18.4356 30.9827 18.4248 31.1708 18.1836C31.7532 17.442 31.0153 17.1288 31.5254 16.5924Z",
    fill: "url(#paint46_radial_41_893)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M23.1802 9.57963C23.1802 9.79324 23.1165 10.002 22.9973 10.1796C22.878 10.3573 22.7086 10.4957 22.5103 10.5774C22.312 10.6592 22.0938 10.6806 21.8833 10.6389C21.6728 10.5972 21.4794 10.4943 21.3276 10.3433C21.1758 10.1923 21.0725 9.99983 21.0306 9.79033C20.9887 9.58083 21.0102 9.36368 21.0924 9.16634C21.1745 8.96899 21.3136 8.80032 21.4921 8.68165C21.6705 8.56297 21.8803 8.49963 22.095 8.49963C22.3828 8.49963 22.6588 8.61342 22.8623 8.81596C23.0658 9.0185 23.1802 9.2932 23.1802 9.57963Z",
    fill: "url(#paint47_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M23.9976 7.16765C23.9976 7.38125 23.9339 7.59006 23.8147 7.76766C23.6954 7.94527 23.5259 8.08369 23.3277 8.16544C23.1294 8.24718 22.9112 8.26857 22.7006 8.22689C22.4901 8.18522 22.2968 8.08236 22.145 7.93132C21.9932 7.78028 21.8899 7.58784 21.848 7.37834C21.8061 7.16884 21.8276 6.95169 21.9098 6.75435C21.9919 6.557 22.131 6.38833 22.3094 6.26966C22.4879 6.15099 22.6977 6.08765 22.9124 6.08765C23.2002 6.08765 23.4762 6.20143 23.6797 6.40397C23.8832 6.60651 23.9976 6.88121 23.9976 7.16765Z",
    fill: "url(#paint48_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M22.2539 12.1283C22.2539 12.3419 22.1903 12.5508 22.071 12.7284C21.9518 12.906 21.7823 13.0444 21.584 13.1261C21.3857 13.2079 21.1675 13.2293 20.957 13.1876C20.7465 13.1459 20.5531 13.0431 20.4013 12.892C20.2496 12.741 20.1462 12.5485 20.1043 12.339C20.0625 12.1295 20.084 11.9124 20.1661 11.715C20.2482 11.5177 20.3873 11.349 20.5658 11.2304C20.7443 11.1117 20.9541 11.0483 21.1687 11.0483C21.4565 11.0483 21.7325 11.1621 21.9361 11.3647C22.1396 11.5672 22.2539 11.8419 22.2539 12.1283Z",
    fill: "url(#paint49_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M21.4219 14.9832C21.4219 15.1968 21.3582 15.4056 21.239 15.5832C21.1197 15.7608 20.9503 15.8992 20.752 15.981C20.5537 16.0627 20.3355 16.0841 20.125 16.0424C19.9144 16.0008 19.7211 15.8979 19.5693 15.7469C19.4175 15.5958 19.3142 15.4034 19.2723 15.1939C19.2304 14.9844 19.2519 14.7672 19.3341 14.5699C19.4162 14.3726 19.5553 14.2039 19.7338 14.0852C19.9122 13.9665 20.122 13.9032 20.3367 13.9032C20.6245 13.9032 20.9005 14.017 21.104 14.2195C21.3075 14.4221 21.4219 14.6968 21.4219 14.9832Z",
    fill: "url(#paint50_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M26.3525 10.35C26.3525 10.5636 26.2889 10.7724 26.1697 10.95C26.0504 11.1276 25.8809 11.2661 25.6826 11.3478C25.4843 11.4296 25.2661 11.4509 25.0556 11.4093C24.8451 11.3676 24.6517 11.2647 24.5 11.1137C24.3482 10.9627 24.2449 10.7702 24.203 10.5607C24.1611 10.3512 24.1826 10.1341 24.2647 9.93672C24.3469 9.73938 24.486 9.5707 24.6644 9.45203C24.8429 9.33336 25.0527 9.27002 25.2673 9.27002C25.5552 9.27002 25.8312 9.3838 26.0347 9.58634C26.2382 9.78888 26.3525 10.0636 26.3525 10.35Z",
    fill: "url(#paint51_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M27.1738 8.0208C27.1738 8.2344 27.1102 8.44321 26.9909 8.62081C26.8717 8.79842 26.7022 8.93684 26.5039 9.01859C26.3056 9.10033 26.0874 9.12172 25.8769 9.08004C25.6664 9.03837 25.473 8.93551 25.3213 8.78447C25.1695 8.63343 25.0661 8.44099 25.0243 8.23149C24.9824 8.02199 25.0039 7.80484 25.086 7.6075C25.1682 7.41015 25.3073 7.24148 25.4857 7.12281C25.6642 7.00414 25.874 6.9408 26.0886 6.9408C26.3764 6.9408 26.6525 7.05458 26.856 7.25712C27.0595 7.45966 27.1738 7.73436 27.1738 8.0208Z",
    fill: "url(#paint52_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M25.3433 12.8556C25.3433 13.0692 25.2796 13.278 25.1604 13.4557C25.0411 13.6333 24.8716 13.7717 24.6734 13.8534C24.4751 13.9352 24.2569 13.9566 24.0463 13.9149C23.8358 13.8732 23.6425 13.7704 23.4907 13.6193C23.3389 13.4683 23.2356 13.2758 23.1937 13.0663C23.1518 12.8568 23.1733 12.6397 23.2555 12.4423C23.3376 12.245 23.4767 12.0763 23.6552 11.9576C23.8336 11.839 24.0434 11.7756 24.2581 11.7756C24.5459 11.7756 24.8219 11.8894 25.0254 12.092C25.2289 12.2945 25.3433 12.5692 25.3433 12.8556Z",
    fill: "url(#paint53_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M24.6416 15.7068C24.6416 15.9204 24.578 16.1292 24.4587 16.3068C24.3395 16.4845 24.17 16.6229 23.9717 16.7046C23.7734 16.7864 23.5552 16.8078 23.3447 16.7661C23.1342 16.7244 22.9408 16.6215 22.789 16.4705C22.6373 16.3195 22.5339 16.127 22.492 15.9175C22.4502 15.708 22.4717 15.4909 22.5538 15.2935C22.6359 15.0962 22.775 14.9275 22.9535 14.8088C23.132 14.6902 23.3418 14.6268 23.5564 14.6268C23.8442 14.6268 24.1202 14.7406 24.3238 14.9432C24.5273 15.1457 24.6416 15.4204 24.6416 15.7068Z",
    fill: "url(#paint54_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M28.038 12.096C28.6394 12.096 29.1269 11.6109 29.1269 11.0124C29.1269 10.414 28.6394 9.92883 28.038 9.92883C27.4367 9.92883 26.9492 10.414 26.9492 11.0124C26.9492 11.6109 27.4367 12.096 28.038 12.096Z",
    fill: "url(#paint55_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M29.9483 8.64006C29.9483 8.85366 29.8846 9.06247 29.7654 9.24007C29.6461 9.41768 29.4766 9.55611 29.2783 9.63785C29.08 9.71959 28.8618 9.74098 28.6513 9.69931C28.4408 9.65763 28.2475 9.55477 28.0957 9.40373C27.9439 9.25269 27.8406 9.06026 27.7987 8.85076C27.7568 8.64126 27.7783 8.4241 27.8604 8.22676C27.9426 8.02942 28.0817 7.86074 28.2601 7.74207C28.4386 7.6234 28.6484 7.56006 28.863 7.56006C29.1509 7.56006 29.4269 7.67384 29.6304 7.87638C29.8339 8.07892 29.9483 8.35362 29.9483 8.64006Z",
    fill: "url(#paint56_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M28.1216 13.6008C28.1216 13.8144 28.0579 14.0232 27.9387 14.2008C27.8195 14.3784 27.65 14.5168 27.4517 14.5985C27.2534 14.6803 27.0352 14.7017 26.8247 14.66C26.6142 14.6183 26.4208 14.5155 26.269 14.3644C26.1173 14.2134 26.0139 14.021 25.972 13.8115C25.9302 13.602 25.9516 13.3848 26.0338 13.1875C26.1159 12.9901 26.255 12.8214 26.4335 12.7028C26.6119 12.5841 26.8217 12.5208 27.0364 12.5208C27.3242 12.5208 27.6002 12.6345 27.8037 12.8371C28.0073 13.0396 28.1216 13.3143 28.1216 13.6008Z",
    fill: "url(#paint57_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M27.3472 16.3656C27.3472 16.5792 27.2835 16.7881 27.1643 16.9657C27.045 17.1433 26.8756 17.2817 26.6773 17.3634C26.479 17.4452 26.2608 17.4666 26.0503 17.4249C25.8397 17.3832 25.6464 17.2804 25.4946 17.1293C25.3428 16.9783 25.2395 16.7858 25.1976 16.5763C25.1557 16.3668 25.1772 16.1497 25.2594 15.9523C25.3415 15.755 25.4806 15.5863 25.6591 15.4677C25.8375 15.349 26.0473 15.2856 26.262 15.2856C26.5498 15.2856 26.8258 15.3994 27.0293 15.602C27.2328 15.8045 27.3472 16.0792 27.3472 16.3656Z",
    fill: "url(#paint58_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M31.7896 11.6316C31.7896 11.8452 31.7259 12.054 31.6067 12.2317C31.4874 12.4093 31.3179 12.5477 31.1196 12.6294C30.9213 12.7112 30.7031 12.7326 30.4926 12.6909C30.2821 12.6492 30.0888 12.5464 29.937 12.3953C29.7852 12.2443 29.6819 12.0518 29.64 11.8423C29.5981 11.6328 29.6196 11.4157 29.7017 11.2183C29.7839 11.021 29.923 10.8523 30.1014 10.7336C30.2799 10.615 30.4897 10.5516 30.7043 10.5516C30.9922 10.5516 31.2682 10.6654 31.4717 10.868C31.6752 11.0705 31.7896 11.3452 31.7896 11.6316Z",
    fill: "url(#paint59_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M32.5562 9.30241C32.5562 9.51602 32.4925 9.72482 32.3733 9.90243C32.254 10.08 32.0845 10.2185 31.8862 10.3002C31.6879 10.3819 31.4697 10.4033 31.2592 10.3617C31.0487 10.32 30.8554 10.2171 30.7036 10.0661C30.5518 9.91505 30.4485 9.72261 30.4066 9.51311C30.3647 9.30361 30.3862 9.08646 30.4683 8.88911C30.5505 8.69177 30.6896 8.5231 30.868 8.40442C31.0465 8.28575 31.2563 8.22241 31.471 8.22241C31.7588 8.22241 32.0348 8.3362 32.2383 8.53874C32.4418 8.74128 32.5562 9.01598 32.5562 9.30241Z",
    fill: "url(#paint60_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M30.7803 14.2236C30.7803 14.4372 30.7166 14.646 30.5974 14.8236C30.4781 15.0012 30.3087 15.1396 30.1104 15.2213C29.9121 15.3031 29.6939 15.3245 29.4834 15.2828C29.2728 15.2411 29.0795 15.1383 28.9277 14.9872C28.7759 14.8362 28.6726 14.6438 28.6307 14.4343C28.5888 14.2248 28.6103 14.0076 28.6925 13.8103C28.7746 13.6129 28.9137 13.4442 29.0922 13.3256C29.2706 13.2069 29.4804 13.1436 29.6951 13.1436C29.9829 13.1436 30.2589 13.2573 30.4624 13.4599C30.6659 13.6624 30.7803 13.9371 30.7803 14.2236Z",
    fill: "url(#paint61_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M30.0239 16.8623C30.0239 17.076 29.9603 17.2848 29.841 17.4624C29.7218 17.64 29.5523 17.7784 29.354 17.8601C29.1557 17.9419 28.9375 17.9633 28.727 17.9216C28.5165 17.8799 28.3231 17.7771 28.1714 17.626C28.0196 17.475 27.9162 17.2825 27.8744 17.073C27.8325 16.8635 27.854 16.6464 27.9361 16.449C28.0183 16.2517 28.1574 16.083 28.3358 15.9644C28.5143 15.8457 28.7241 15.7823 28.9387 15.7823C29.2265 15.7823 29.5026 15.8961 29.7061 16.0987C29.9096 16.3012 30.0239 16.5759 30.0239 16.8623Z",
    fill: "url(#paint62_radial_41_893)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2525 7.2396C23.2525 7.31918 23.221 7.39555 23.1648 7.45216C23.1086 7.50877 23.0323 7.54105 22.9523 7.542C22.872 7.54106 22.7953 7.5089 22.7385 7.45239C22.6817 7.39588 22.6494 7.31951 22.6484 7.2396C22.6494 7.16002 22.6818 7.08402 22.7387 7.02809C22.7956 6.97216 22.8723 6.94079 22.9523 6.9408C23.0319 6.9408 23.1083 6.97228 23.1646 7.02831C23.2209 7.08435 23.2525 7.16035 23.2525 7.2396Z",
    fill: "url(#paint63_radial_41_893)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4456 9.58316C22.4447 9.66307 22.4124 9.73945 22.3556 9.79596C22.2988 9.85247 22.222 9.88463 22.1417 9.88556C22.0612 9.88556 21.9839 9.8537 21.9269 9.79699C21.8699 9.74028 21.8379 9.66336 21.8379 9.58316C21.8379 9.50296 21.8699 9.42604 21.9269 9.36933C21.9839 9.31262 22.0612 9.28076 22.1417 9.28076C22.222 9.2817 22.2988 9.31386 22.3556 9.37037C22.4124 9.42688 22.4447 9.50325 22.4456 9.58316Z",
    fill: "url(#paint64_radial_41_893)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4725 12.0852C21.4725 12.145 21.4546 12.2035 21.4213 12.2532C21.3879 12.303 21.3404 12.3417 21.2849 12.3646C21.2294 12.3875 21.1683 12.3935 21.1093 12.3818C21.0504 12.3702 20.9962 12.3414 20.9537 12.2991C20.9112 12.2568 20.8823 12.2029 20.8706 12.1442C20.8589 12.0856 20.8649 12.0248 20.8879 11.9695C20.9109 11.9143 20.9498 11.867 20.9998 11.8338C21.0498 11.8006 21.1085 11.7828 21.1686 11.7828C21.2085 11.7828 21.248 11.7907 21.2849 11.8059C21.3218 11.8211 21.3552 11.8433 21.3835 11.8714C21.4117 11.8995 21.4341 11.9328 21.4493 11.9695C21.4646 12.0062 21.4725 12.0455 21.4725 12.0852Z",
    fill: "url(#paint65_radial_41_893)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6697 14.886C20.6688 14.9659 20.6365 15.0423 20.5797 15.0988C20.5229 15.1553 20.4462 15.1875 20.3659 15.1884C20.2853 15.1884 20.208 15.1566 20.151 15.0998C20.094 15.0431 20.062 14.9662 20.062 14.886C20.062 14.8058 20.094 14.7289 20.151 14.6722C20.208 14.6155 20.2853 14.5836 20.3659 14.5836C20.4462 14.5846 20.5229 14.6167 20.5797 14.6732C20.6365 14.7297 20.6688 14.8061 20.6697 14.886Z",
    fill: "url(#paint66_radial_41_893)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4065 8.00634C26.4072 8.06645 26.3899 8.12541 26.3568 8.17569C26.3237 8.22596 26.2763 8.26528 26.2206 8.28861C26.165 8.31194 26.1036 8.31824 26.0443 8.30668C25.985 8.29513 25.9305 8.26626 25.8878 8.22375C25.8451 8.18124 25.8161 8.12703 25.8045 8.06804C25.7929 8.00904 25.7992 7.94795 25.8227 7.89254C25.8461 7.83714 25.8856 7.78995 25.9361 7.757C25.9866 7.72405 26.0459 7.70683 26.1063 7.70754C26.1859 7.70754 26.2623 7.73902 26.3186 7.79506C26.3749 7.85109 26.4065 7.92709 26.4065 8.00634Z",
    fill: "url(#paint67_radial_41_893)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5965 10.35C25.5965 10.4302 25.5645 10.5071 25.5075 10.5638C25.4505 10.6205 25.3732 10.6524 25.2926 10.6524C25.212 10.6524 25.1348 10.6205 25.0778 10.5638C25.0208 10.5071 24.9888 10.4302 24.9888 10.35C24.9888 10.2698 25.0208 10.1929 25.0778 10.1362C25.1348 10.0795 25.212 10.0476 25.2926 10.0476C25.3732 10.0476 25.4505 10.0795 25.5075 10.1362C25.5645 10.1929 25.5965 10.2698 25.5965 10.35Z",
    fill: "url(#paint68_radial_41_893)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6236 12.852C24.6227 12.9319 24.5904 13.0083 24.5336 13.0648C24.4768 13.1213 24.4001 13.1535 24.3198 13.1544C24.2398 13.1535 24.1635 13.1212 24.1072 13.0646C24.051 13.008 24.0195 12.9316 24.0195 12.852C24.0195 12.7728 24.0512 12.6968 24.1075 12.6407C24.1638 12.5847 24.2401 12.5532 24.3198 12.5532C24.3997 12.5532 24.4765 12.5846 24.5334 12.6405C24.5902 12.6965 24.6227 12.7724 24.6236 12.852Z",
    fill: "url(#paint69_radial_41_893)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8204 15.6528C23.8195 15.7327 23.7872 15.8091 23.7304 15.8656C23.6736 15.9221 23.5968 15.9543 23.5166 15.9552C23.4366 15.9543 23.3602 15.922 23.304 15.8654C23.2478 15.8088 23.2163 15.7324 23.2163 15.6528C23.2163 15.5736 23.2479 15.4976 23.3042 15.4415C23.3606 15.3855 23.4369 15.354 23.5166 15.354C23.5965 15.354 23.6733 15.3854 23.7301 15.4413C23.787 15.4972 23.8195 15.5732 23.8204 15.6528Z",
    fill: "url(#paint70_radial_41_893)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1521 8.6724C29.1521 8.7526 29.1201 8.82951 29.0632 8.88622C29.0062 8.94294 28.9289 8.9748 28.8483 8.9748C28.7882 8.9748 28.7294 8.95706 28.6795 8.92383C28.6295 8.8906 28.5906 8.84337 28.5676 8.78812C28.5446 8.73286 28.5385 8.67206 28.5503 8.6134C28.562 8.55474 28.5909 8.50086 28.6334 8.45857C28.6759 8.41627 28.7301 8.38747 28.789 8.37581C28.848 8.36414 28.9091 8.37013 28.9646 8.39301C29.0201 8.4159 29.0676 8.45466 29.1009 8.50439C29.1343 8.55412 29.1521 8.61259 29.1521 8.6724Z",
    fill: "url(#paint71_radial_41_893)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3421 11.0196C28.3421 11.0794 28.3243 11.1379 28.2909 11.1876C28.2575 11.2373 28.21 11.2761 28.1545 11.299C28.099 11.3219 28.0379 11.3278 27.979 11.3162C27.92 11.3045 27.8659 11.2757 27.8234 11.2334C27.7809 11.1911 27.7519 11.1372 27.7402 11.0786C27.7285 11.0199 27.7345 10.9591 27.7575 10.9039C27.7805 10.8486 27.8194 10.8014 27.8694 10.7681C27.9194 10.7349 27.9781 10.7172 28.0382 10.7172C28.0783 10.7167 28.118 10.7242 28.1551 10.7392C28.1922 10.7542 28.2259 10.7765 28.2542 10.8047C28.2825 10.8329 28.3049 10.8664 28.32 10.9033C28.3351 10.9402 28.3426 10.9797 28.3421 11.0196Z",
    fill: "url(#paint72_radial_41_893)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3688 13.518C27.3688 13.5976 27.3372 13.674 27.281 13.7306C27.2248 13.7872 27.1485 13.8195 27.0685 13.8204C26.9882 13.8195 26.9115 13.7873 26.8547 13.7308C26.7979 13.6743 26.7656 13.5979 26.7646 13.518C26.7656 13.4385 26.798 13.3625 26.8549 13.3065C26.9118 13.2506 26.9885 13.2192 27.0685 13.2192C27.1481 13.2192 27.2245 13.2507 27.2808 13.3068C27.3371 13.3628 27.3688 13.4388 27.3688 13.518Z",
    fill: "url(#paint73_radial_41_893)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5657 16.3188C26.5664 16.379 26.5491 16.4379 26.516 16.4882C26.4829 16.5385 26.4355 16.5778 26.3798 16.6011C26.3241 16.6244 26.2627 16.6307 26.2035 16.6192C26.1442 16.6076 26.0897 16.5788 26.047 16.5362C26.0043 16.4937 25.9753 16.4395 25.9637 16.3805C25.9521 16.3215 25.9584 16.2604 25.9818 16.205C26.0053 16.1496 26.0448 16.1025 26.0953 16.0695C26.1458 16.0365 26.2051 16.0193 26.2655 16.02C26.3451 16.02 26.4215 16.0515 26.4778 16.1076C26.5341 16.1636 26.5657 16.2396 26.5657 16.3188Z",
    fill: "url(#paint74_radial_41_893)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8001 9.27365C31.8008 9.33361 31.7836 9.39243 31.7506 9.44263C31.7177 9.49283 31.6705 9.53215 31.615 9.55559C31.5596 9.57903 31.4984 9.58553 31.4392 9.57428C31.38 9.56302 31.3255 9.5345 31.2827 9.49236C31.2398 9.45021 31.2105 9.39634 31.1985 9.33759C31.1865 9.27883 31.1923 9.21784 31.2152 9.16238C31.238 9.10691 31.277 9.05947 31.327 9.02608C31.3771 8.99269 31.436 8.97486 31.4962 8.97485C31.5762 8.97485 31.6529 9.00621 31.7098 9.06215C31.7667 9.11808 31.7991 9.19408 31.8001 9.27365Z",
    fill: "url(#paint75_radial_41_893)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M30.99 11.6172C30.99 11.6974 30.958 11.7743 30.901 11.831C30.8441 11.8878 30.7668 11.9196 30.6862 11.9196C30.6261 11.9196 30.5673 11.9019 30.5174 11.8687C30.4674 11.8354 30.4285 11.7882 30.4055 11.7329C30.3825 11.6777 30.3764 11.6169 30.3882 11.5582C30.3999 11.4996 30.4288 11.4457 30.4713 11.4034C30.5138 11.3611 30.568 11.3323 30.6269 11.3206C30.6858 11.309 30.7469 11.315 30.8025 11.3378C30.858 11.3607 30.9054 11.3995 30.9388 11.4492C30.9722 11.4989 30.99 11.5574 30.99 11.6172Z",
    fill: "url(#paint76_radial_41_893)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0242 14.1192C30.0242 14.179 30.0064 14.2374 29.973 14.2872C29.9396 14.3369 29.8922 14.3757 29.8366 14.3986C29.7811 14.4214 29.72 14.4274 29.6611 14.4158C29.6021 14.4041 29.548 14.3753 29.5055 14.333C29.463 14.2907 29.4341 14.2368 29.4223 14.1782C29.4106 14.1195 29.4166 14.0587 29.4396 14.0034C29.4626 13.9482 29.5016 13.901 29.5515 13.8677C29.6015 13.8345 29.6603 13.8168 29.7204 13.8168C29.801 13.8168 29.8782 13.8486 29.9352 13.9053C29.9922 13.9621 30.0242 14.039 30.0242 14.1192Z",
    fill: "url(#paint77_radial_41_893)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.214 16.92C29.213 16.9995 29.1806 17.0755 29.1237 17.1315C29.0668 17.1874 28.9901 17.2188 28.9101 17.2188C28.8305 17.2188 28.7541 17.1873 28.6978 17.1312C28.6415 17.0752 28.6099 16.9992 28.6099 16.92C28.6099 16.8404 28.6414 16.764 28.6976 16.7074C28.7538 16.6508 28.8301 16.6185 28.9101 16.6176C28.9904 16.6185 29.0671 16.6506 29.1239 16.7072C29.1807 16.7637 29.213 16.84 29.214 16.92Z",
    fill: "url(#paint78_radial_41_893)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.7444 5.48282C23.7444 5.48282 24.4679 6.00482 24.9345 5.82482C25.5025 5.59802 25.5603 5.48282 26.1283 5.99402C26.6962 6.50522 26.3562 7.01282 25.8425 7.23602C25.3288 7.45922 25.119 8.70482 24.5945 9.10082C24.07 9.49682 23.2886 8.59322 23.6287 8.02082C23.7784 7.77924 23.8478 7.49686 23.827 7.21379C23.8062 6.93072 23.6963 6.66137 23.5129 6.44402C23.1729 6.04802 23.1729 5.14442 23.7444 5.48282Z",
    fill: "url(#paint79_radial_41_893)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.0512 10.9116C20.0512 10.9116 20.3912 9.44278 21.2413 10.062C22.0914 10.6812 22.3772 10.2888 23.003 10.3464C23.6288 10.404 24.7104 10.6308 25.1083 11.0664C25.5062 11.502 25.3904 12.1464 24.6525 12.0276C23.9145 11.9088 24.1388 12.312 23.7445 12.9312C23.3502 13.5504 22.1529 13.8348 22.1529 12.8736C22.1529 11.9124 22.2071 11.2932 21.755 11.1816C21.3028 11.07 21.0713 11.0664 20.6698 11.6316C20.2682 12.1968 19.7112 11.592 20.0512 10.9116Z",
    fill: "url(#paint80_radial_41_893)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.8933 8.69765C25.8933 8.69765 26.9243 8.43125 27.5067 8.87765C28.0891 9.32405 28.4906 9.23765 28.5919 9.72365C28.6932 10.2096 28.3676 10.3896 27.9661 10.4796C27.8579 10.4917 27.7552 10.5334 27.6696 10.6003C27.5839 10.6671 27.5187 10.7563 27.4811 10.858C27.4436 10.9597 27.4352 11.0697 27.457 11.1758C27.4787 11.282 27.5298 11.38 27.6043 11.4588C27.9661 11.9484 27.4596 12.42 27.04 12.5172C26.6204 12.6144 25.6799 12.1572 25.9548 11.4156C26.2297 10.674 26.1791 9.97565 25.9114 9.67685C25.6437 9.37805 25.4918 8.83085 25.8933 8.69765Z",
    fill: "url(#paint81_radial_41_893)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.8302 15.2532C27.0359 15.3463 27.2013 15.5098 27.2962 15.7139C27.3911 15.918 27.4093 16.1493 27.3475 16.3656C27.1304 17.172 27.0798 16.92 26.4576 17.3592C25.8354 17.7984 26.6421 18.1044 26.8193 18.414C26.9966 18.7236 28.1252 18.4752 28.2663 17.7912C28.4073 17.1072 28.3278 16.6176 28.628 16.182C28.9282 15.7464 29.3117 15.3756 28.8161 15.0048C28.3205 14.634 26.1465 14.1984 26.8302 15.2532Z",
    fill: "url(#paint82_radial_41_893)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.6622 7.00917C29.6622 7.00917 30.3857 6.33957 30.8487 6.88317C31.3117 7.42677 31.1055 7.39077 32.1003 7.32957C33.0951 7.26837 33.124 7.74357 32.9974 8.18997C32.8708 8.63637 32.2269 8.79837 31.8109 8.54997C31.3949 8.30157 30.8161 8.42037 30.364 8.45277C29.9118 8.48517 29.948 8.03517 29.8178 7.87677C29.6875 7.71837 29.503 7.13517 29.6622 7.00917Z",
    fill: "url(#paint83_radial_41_893)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.4852 7.21802C22.4657 7.22205 22.4481 7.23267 22.4355 7.24808C22.4229 7.26349 22.416 7.28275 22.416 7.30262C22.416 7.32249 22.4229 7.34175 22.4355 7.35716C22.4481 7.37257 22.4657 7.38318 22.4852 7.38722C22.5048 7.38318 22.5223 7.37257 22.5349 7.35716C22.5475 7.34175 22.5544 7.32249 22.5544 7.30262C22.5544 7.28275 22.5475 7.26349 22.5349 7.24808C22.5223 7.23267 22.5048 7.22205 22.4852 7.21802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.305 11.2607C24.2855 11.2648 24.2679 11.2754 24.2553 11.2908C24.2427 11.3062 24.2358 11.3255 24.2358 11.3453C24.2358 11.3652 24.2427 11.3845 24.2553 11.3999C24.2679 11.4153 24.2855 11.4259 24.305 11.4299C24.3246 11.4259 24.3421 11.4153 24.3547 11.3999C24.3673 11.3845 24.3742 11.3652 24.3742 11.3453C24.3742 11.3255 24.3673 11.3062 24.3547 11.2908C24.3421 11.2754 24.3246 11.2648 24.305 11.2607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.1102 10.0151C28.0907 10.0192 28.0731 10.0298 28.0605 10.0452C28.0479 10.0606 28.041 10.0799 28.041 10.0997C28.041 10.1196 28.0479 10.1389 28.0605 10.1543C28.0731 10.1697 28.0907 10.1803 28.1102 10.1843C28.1298 10.1803 28.1473 10.1697 28.1599 10.1543C28.1725 10.1389 28.1794 10.1196 28.1794 10.0997C28.1794 10.0799 28.1725 10.0606 28.1599 10.0452C28.1473 10.0298 28.1298 10.0192 28.1102 10.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.9682 14.9832C30.9451 14.9832 30.9231 14.9923 30.9068 15.0085C30.8905 15.0247 30.8813 15.0466 30.8813 15.0696C30.8813 15.0925 30.8905 15.1144 30.9068 15.1306C30.9231 15.1469 30.9451 15.156 30.9682 15.156C30.9912 15.156 31.0133 15.1469 31.0296 15.1306C31.0458 15.1144 31.055 15.0925 31.055 15.0696C31.055 15.0466 31.0458 15.0247 31.0296 15.0085C31.0133 14.9923 30.9912 14.9832 30.9682 14.9832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.639 14.2955C21.6195 14.2996 21.6019 14.3102 21.5893 14.3256C21.5767 14.341 21.5698 14.3603 21.5698 14.3801C21.5698 14.4 21.5767 14.4193 21.5893 14.4347C21.6019 14.4501 21.6195 14.4607 21.639 14.4647C21.6586 14.4607 21.6761 14.4501 21.6887 14.4347C21.7013 14.4193 21.7082 14.4 21.7082 14.3801C21.7082 14.3603 21.7013 14.341 21.6887 14.3256C21.6761 14.3102 21.6586 14.2996 21.639 14.2955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.5331 6.70679C24.5135 6.71082 24.496 6.72144 24.4834 6.73685C24.4707 6.75226 24.4639 6.77152 24.4639 6.79139C24.4639 6.81126 24.4707 6.83052 24.4834 6.84593C24.496 6.86134 24.5135 6.87195 24.5331 6.87599C24.5526 6.87195 24.5702 6.86134 24.5828 6.84593C24.5954 6.83052 24.6022 6.81126 24.6022 6.79139C24.6022 6.77152 24.5954 6.75226 24.5828 6.73685C24.5702 6.72144 24.5526 6.71082 24.5331 6.70679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0087 9.30603C25.9857 9.30603 25.9636 9.31513 25.9473 9.33134C25.931 9.34754 25.9219 9.36952 25.9219 9.39243C25.9219 9.41534 25.931 9.43732 25.9473 9.45352C25.9636 9.46973 25.9857 9.47883 26.0087 9.47883C26.0317 9.47883 26.0538 9.46973 26.0701 9.45352C26.0864 9.43732 26.0955 9.41534 26.0955 9.39243C26.0955 9.36952 26.0864 9.34754 26.0701 9.33134C26.0538 9.31513 26.0317 9.30603 26.0087 9.30603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3421 11.4012C21.3226 11.4053 21.305 11.4159 21.2924 11.4313C21.2798 11.4467 21.2729 11.466 21.2729 11.4858C21.2729 11.5057 21.2798 11.525 21.2924 11.5404C21.305 11.5558 21.3226 11.5664 21.3421 11.5704C21.3617 11.5664 21.3792 11.5558 21.3918 11.5404C21.4044 11.525 21.4113 11.5057 21.4113 11.4858C21.4113 11.466 21.4044 11.4467 21.3918 11.4313C21.3792 11.4159 21.3617 11.4053 21.3421 11.4012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1551 13.6799C25.1356 13.684 25.118 13.6946 25.1054 13.71C25.0928 13.7254 25.0859 13.7447 25.0859 13.7645C25.0859 13.7844 25.0928 13.8037 25.1054 13.8191C25.118 13.8345 25.1356 13.8451 25.1551 13.8491C25.1747 13.8451 25.1922 13.8345 25.2048 13.8191C25.2174 13.8037 25.2243 13.7844 25.2243 13.7645C25.2243 13.7447 25.2174 13.7254 25.2048 13.71C25.1922 13.6946 25.1747 13.684 25.1551 13.6799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1342 11.8512C29.1112 11.8512 29.0891 11.8603 29.0728 11.8765C29.0565 11.8927 29.0474 11.9147 29.0474 11.9376C29.0474 11.9605 29.0565 11.9825 29.0728 11.9987C29.0891 12.0149 29.1112 12.024 29.1342 12.024C29.1572 12.024 29.1793 12.0149 29.1956 11.9987C29.2119 11.9825 29.221 11.9605 29.221 11.9376C29.221 11.9147 29.2119 11.8927 29.1956 11.8765C29.1793 11.8603 29.1572 11.8512 29.1342 11.8512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9735 11.7972C31.9539 11.8013 31.9364 11.8119 31.9238 11.8273C31.9112 11.8427 31.9043 11.862 31.9043 11.8818C31.9043 11.9017 31.9112 11.921 31.9238 11.9364C31.9364 11.9518 31.9539 11.9624 31.9735 11.9664C31.993 11.9624 32.0106 11.9518 32.0232 11.9364C32.0358 11.921 32.0427 11.9017 32.0427 11.8818C32.0427 11.862 32.0358 11.8427 32.0232 11.8273C32.0106 11.8119 31.993 11.8013 31.9735 11.7972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4398 16.884C30.4202 16.8881 30.4027 16.8987 30.3901 16.9141C30.3775 16.9295 30.3706 16.9488 30.3706 16.9686C30.3706 16.9885 30.3775 17.0078 30.3901 17.0232C30.4027 17.0386 30.4202 17.0492 30.4398 17.0532C30.4593 17.0492 30.4769 17.0386 30.4895 17.0232C30.5021 17.0078 30.509 16.9885 30.509 16.9686C30.509 16.9488 30.5021 16.9295 30.4895 16.9141C30.4769 16.8987 30.4593 16.8881 30.4398 16.884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.492 14.7924C27.4725 14.7964 27.4549 14.807 27.4423 14.8224C27.4297 14.8378 27.4229 14.8571 27.4229 14.877C27.4229 14.8968 27.4297 14.9161 27.4423 14.9315C27.4549 14.9469 27.4725 14.9575 27.492 14.9616C27.5116 14.9575 27.5291 14.9469 27.5417 14.9315C27.5543 14.9161 27.5612 14.8968 27.5612 14.877C27.5612 14.8571 27.5543 14.8378 27.5417 14.8224C27.5291 14.807 27.5116 14.7964 27.492 14.7924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8158 12.87C19.7962 12.874 19.7787 12.8846 19.7661 12.9001C19.7535 12.9155 19.7466 12.9347 19.7466 12.9546C19.7466 12.9745 19.7535 12.9937 19.7661 13.0091C19.7787 13.0245 19.7962 13.0352 19.8158 13.0392C19.8353 13.0352 19.8529 13.0245 19.8655 13.0091C19.8781 12.9937 19.885 12.9745 19.885 12.9546C19.885 12.9347 19.8781 12.9155 19.8655 12.9001C19.8529 12.8846 19.8353 12.874 19.8158 12.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0531 12.4164C23.0301 12.4164 23.008 12.4255 22.9917 12.4417C22.9755 12.4579 22.9663 12.4799 22.9663 12.5028C22.9663 12.5257 22.9755 12.5477 22.9917 12.5639C23.008 12.5801 23.0301 12.5892 23.0531 12.5892C23.0761 12.5892 23.0982 12.5801 23.1145 12.5639C23.1308 12.5477 23.1399 12.5257 23.1399 12.5028C23.1399 12.4799 23.1308 12.4579 23.1145 12.4417C23.0982 12.4255 23.0761 12.4164 23.0531 12.4164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6009 16.7723C22.5814 16.7764 22.5638 16.787 22.5512 16.8024C22.5386 16.8178 22.5317 16.8371 22.5317 16.8569C22.5317 16.8768 22.5386 16.8961 22.5512 16.9115C22.5638 16.9269 22.5814 16.9375 22.6009 16.9415C22.6205 16.9375 22.638 16.9269 22.6506 16.9115C22.6632 16.8961 22.6701 16.8768 22.6701 16.8569C22.6701 16.8371 22.6632 16.8178 22.6506 16.8024C22.638 16.787 22.6205 16.7764 22.6009 16.7723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9062 6.87598C28.8831 6.87598 28.861 6.88508 28.8448 6.90128C28.8285 6.91749 28.8193 6.93946 28.8193 6.96238C28.8193 6.98529 28.8285 7.00727 28.8448 7.02347C28.861 7.03967 28.8831 7.04878 28.9062 7.04878C28.9292 7.04878 28.9513 7.03967 28.9675 7.02347C28.9838 7.00727 28.993 6.98529 28.993 6.96238C28.993 6.93946 28.9838 6.91749 28.9675 6.90128C28.9513 6.88508 28.9292 6.87598 28.9062 6.87598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0804 14.8896C24.0609 14.8937 24.0433 14.9043 24.0307 14.9197C24.0181 14.9351 24.0112 14.9544 24.0112 14.9742C24.0112 14.9941 24.0181 15.0134 24.0307 15.0288C24.0433 15.0442 24.0609 15.0548 24.0804 15.0588C24.1 15.0548 24.1175 15.0442 24.1301 15.0288C24.1427 15.0134 24.1496 14.9941 24.1496 14.9742C24.1496 14.9544 24.1427 14.9351 24.1301 14.9197C24.1175 14.9043 24.1 14.8937 24.0804 14.8896Z",
    fill: "white"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2049 11.25C30.1916 11.2533 30.1797 11.2609 30.1713 11.2717C30.1628 11.2825 30.1582 11.2957 30.1582 11.3094C30.1582 11.3231 30.1628 11.3363 30.1713 11.3471C30.1797 11.3579 30.1916 11.3655 30.2049 11.3688C30.2182 11.3655 30.2301 11.3579 30.2385 11.3471C30.247 11.3363 30.2516 11.3231 30.2516 11.3094C30.2516 11.2957 30.247 11.2825 30.2385 11.2717C30.2301 11.2609 30.2182 11.2533 30.2049 11.25Z",
    fill: "#C85600"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4637 10.7784C22.4504 10.7817 22.4385 10.7894 22.4301 10.8001C22.4216 10.8109 22.417 10.8242 22.417 10.8378C22.417 10.8515 22.4216 10.8648 22.4301 10.8755C22.4385 10.8863 22.4504 10.894 22.4637 10.8972C22.477 10.894 22.4889 10.8863 22.4973 10.8755C22.5058 10.8648 22.5104 10.8515 22.5104 10.8378C22.5104 10.8242 22.5058 10.8109 22.4973 10.8001C22.4889 10.7894 22.477 10.7817 22.4637 10.7784Z",
    fill: "#C85600"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8616 7.38721C22.8462 7.38721 22.8315 7.39328 22.8207 7.40408C22.8098 7.41488 22.8037 7.42953 22.8037 7.44481C22.8037 7.46008 22.8098 7.47473 22.8207 7.48554C22.8315 7.49634 22.8462 7.50241 22.8616 7.50241C22.8769 7.50241 22.8917 7.49634 22.9025 7.48554C22.9134 7.47473 22.9195 7.46008 22.9195 7.44481C22.9195 7.42953 22.9134 7.41488 22.9025 7.40408C22.8917 7.39328 22.8769 7.38721 22.8616 7.38721Z",
    fill: "#C85600"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M24.909 12.9276C24.8936 12.9276 24.8789 12.9337 24.868 12.9445C24.8572 12.9553 24.8511 12.9699 24.8511 12.9852C24.8511 13.0005 24.8572 13.0151 24.868 13.0259C24.8789 13.0367 24.8936 13.0428 24.909 13.0428C24.9243 13.0428 24.939 13.0367 24.9499 13.0259C24.9607 13.0151 24.9668 13.0005 24.9668 12.9852C24.9668 12.9699 24.9607 12.9553 24.9499 12.9445C24.939 12.9337 24.9243 12.9276 24.909 12.9276Z",
    fill: "#C85600"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1341 12.3624C20.1208 12.3657 20.1089 12.3733 20.1005 12.3841C20.092 12.3949 20.0874 12.4081 20.0874 12.4218C20.0874 12.4355 20.092 12.4487 20.1005 12.4595C20.1089 12.4703 20.1208 12.4779 20.1341 12.4812C20.1432 12.4834 20.1526 12.4836 20.1617 12.4816C20.1709 12.4797 20.1794 12.4757 20.1868 12.47C20.1941 12.4643 20.2001 12.457 20.2042 12.4486C20.2083 12.4403 20.2104 12.4311 20.2104 12.4218C20.2104 12.4125 20.2083 12.4033 20.2042 12.395C20.2001 12.3866 20.1941 12.3793 20.1868 12.3736C20.1794 12.3679 20.1709 12.3639 20.1617 12.3619C20.1526 12.36 20.1432 12.3602 20.1341 12.3624Z",
    fill: "#C85600"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5789 14.4C27.5635 14.4 27.5488 14.4061 27.5379 14.4169C27.5271 14.4277 27.521 14.4423 27.521 14.4576C27.521 14.4729 27.5271 14.4876 27.5379 14.4984C27.5488 14.5092 27.5635 14.5152 27.5789 14.5152C27.5942 14.5152 27.6089 14.5092 27.6198 14.4984C27.6307 14.4876 27.6368 14.4729 27.6368 14.4576C27.6368 14.4423 27.6307 14.4277 27.6198 14.4169C27.6089 14.4061 27.5942 14.4 27.5789 14.4Z",
    fill: "#C85600"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5208 16.7725C27.5075 16.7758 27.4956 16.7834 27.4872 16.7942C27.4787 16.8049 27.4741 16.8182 27.4741 16.8319C27.4741 16.8455 27.4787 16.8588 27.4872 16.8696C27.4956 16.8803 27.5075 16.888 27.5208 16.8913C27.5341 16.888 27.546 16.8803 27.5544 16.8696C27.5629 16.8588 27.5675 16.8455 27.5675 16.8319C27.5675 16.8182 27.5629 16.8049 27.5544 16.7942C27.546 16.7834 27.5341 16.7758 27.5208 16.7725Z",
    fill: "#C85600"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9539 16.7148C21.9406 16.7181 21.9287 16.7258 21.9203 16.7365C21.9118 16.7473 21.9072 16.7606 21.9072 16.7742C21.9072 16.7879 21.9118 16.8012 21.9203 16.812C21.9287 16.8227 21.9406 16.8304 21.9539 16.8336C21.9672 16.8304 21.9791 16.8227 21.9875 16.812C21.996 16.8012 22.0006 16.7879 22.0006 16.7742C22.0006 16.7606 21.996 16.7473 21.9875 16.7365C21.9791 16.7258 21.9672 16.7181 21.9539 16.7148Z",
    fill: "#C85600"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9739 13.4928C22.9606 13.4961 22.9488 13.5037 22.9403 13.5145C22.9318 13.5253 22.9272 13.5385 22.9272 13.5522C22.9272 13.5659 22.9318 13.5791 22.9403 13.5899C22.9488 13.6007 22.9606 13.6083 22.9739 13.6116C22.9873 13.6083 22.9991 13.6007 23.0076 13.5899C23.016 13.5791 23.0206 13.5659 23.0206 13.5522C23.0206 13.5385 23.016 13.5253 23.0076 13.5145C22.9991 13.5037 22.9873 13.4961 22.9739 13.4928Z",
    fill: "#C85600"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2586 16.488C28.2453 16.4913 28.2334 16.499 28.225 16.5097C28.2165 16.5205 28.2119 16.5338 28.2119 16.5474C28.2119 16.5611 28.2165 16.5744 28.225 16.5851C28.2334 16.5959 28.2453 16.6035 28.2586 16.6068C28.2719 16.6035 28.2838 16.5959 28.2922 16.5851C28.3007 16.5744 28.3053 16.5611 28.3053 16.5474C28.3053 16.5338 28.3007 16.5205 28.2922 16.5097C28.2838 16.499 28.2719 16.4913 28.2586 16.488Z",
    fill: "#C85600"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4866 17.7913C28.4712 17.7913 28.4565 17.7973 28.4457 17.8081C28.4348 17.8189 28.4287 17.8336 28.4287 17.8489C28.4287 17.8641 28.4348 17.8788 28.4457 17.8896C28.4565 17.9004 28.4712 17.9065 28.4866 17.9065C28.5019 17.9065 28.5167 17.9004 28.5275 17.8896C28.5384 17.8788 28.5445 17.8641 28.5445 17.8489C28.5445 17.8336 28.5384 17.8189 28.5275 17.8081C28.5167 17.7973 28.5019 17.7913 28.4866 17.7913Z",
    fill: "#C85600"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0457 7.89478C21.0324 7.89807 21.0205 7.9057 21.0121 7.91647C21.0036 7.92723 20.999 7.94051 20.999 7.95418C20.999 7.96784 21.0036 7.98112 21.0121 7.99188C21.0205 8.00265 21.0324 8.01028 21.0457 8.01358C21.059 8.01028 21.0709 8.00265 21.0793 7.99188C21.0878 7.98112 21.0924 7.96784 21.0924 7.95418C21.0924 7.94051 21.0878 7.92723 21.0793 7.91647C21.0709 7.9057 21.059 7.89807 21.0457 7.89478Z",
    fill: "#C85600"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1091 9.98645C31.0938 9.98645 31.0791 9.99252 31.0682 10.0033C31.0574 10.0141 31.0513 10.0288 31.0513 10.0441C31.0513 10.0593 31.0574 10.074 31.0682 10.0848C31.0791 10.0956 31.0938 10.1017 31.1091 10.1017C31.1245 10.1017 31.1392 10.0956 31.1501 10.0848C31.1609 10.074 31.167 10.0593 31.167 10.0441C31.167 10.0288 31.1609 10.0141 31.1501 10.0033C31.1392 9.99252 31.1245 9.98645 31.1091 9.98645Z",
    fill: "#C85600"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7903 8.5752C26.7749 8.5752 26.7602 8.58126 26.7494 8.59207C26.7385 8.60287 26.7324 8.61752 26.7324 8.6328C26.7324 8.64807 26.7385 8.66272 26.7494 8.67353C26.7602 8.68433 26.7749 8.6904 26.7903 8.6904C26.8056 8.6904 26.8204 8.68433 26.8312 8.67353C26.8421 8.66272 26.8482 8.64807 26.8482 8.6328C26.8482 8.61752 26.8421 8.60287 26.8312 8.59207C26.8204 8.58126 26.8056 8.5752 26.7903 8.5752Z",
    fill: "#C85600"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9558 13.6404C31.9232 14.9184 31.2034 14.0472 31.3915 15.3576C31.5796 16.668 30.639 16.1064 30.7476 17.1972C30.8561 18.288 30.0603 17.9172 30.0603 18.5076C30.0603 19.098 29.59 18.9468 29.3368 18.6336C29.0836 18.3204 28.7363 18.216 28.078 18.468C27.4196 18.72 26.7359 18.2592 26.2693 17.8524C25.8026 17.4456 24.797 18.2124 24.4172 17.8848C24.2136 17.6996 23.9658 17.5693 23.6974 17.5063C23.4289 17.4433 23.1487 17.4497 22.8834 17.5248C22.1599 17.6508 21.7982 17.586 21.3135 17.0856C20.8288 16.5852 19.9968 17.3052 19.6531 17.0244C19.3095 16.7436 19.2444 16.3404 18.5679 16.4952C18.2347 16.5535 17.8915 16.5096 17.584 16.3692C17.6274 16.5276 17.7685 16.6464 18.0542 16.6572C18.6728 16.6788 18.7162 16.7004 19.248 17.1252C19.7797 17.55 19.9931 17.3556 20.6117 17.3124C21.2303 17.2692 21.0567 17.3988 21.592 17.7372C22.1274 18.0756 22.3987 17.8848 22.8472 17.7588C23.2958 17.6328 23.549 17.7156 24.1061 18.162C24.6632 18.6084 24.8079 18.4392 25.3396 18.288C25.8714 18.1368 26.0233 18.1836 26.4465 18.648C26.6197 18.8386 26.8477 18.9716 27.0994 19.0289C27.3511 19.0862 27.6144 19.0651 27.8537 18.9684C28.2805 18.8208 28.4288 18.6084 28.8774 19.1376C29.3259 19.6668 30.7584 19.746 30.6861 19.0944C30.6137 18.4428 30.9827 18.432 31.1708 18.1908C31.7387 17.4708 31.0008 17.1432 31.5108 16.6068C32.1077 16.0128 31.623 15.3936 32.0209 14.8824C32.6467 14.2056 32.162 13.5 32.4477 13.104C32.7335 12.708 32.9686 12.6468 32.9903 12.2004C32.6503 12.708 31.9811 12.6288 31.9558 13.6404Z",
    fill: "url(#paint84_radial_41_893)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.6655 19.3321C19.5011 18.9721 19.2696 18.1621 19.8773 17.8093C20.7781 17.3809 20.5827 16.4773 21.0277 16.1929C21.4726 15.9085 21.8199 15.9517 22.0152 15.3037C22.1165 14.9761 22.1454 14.6125 22.4782 14.4145C22.811 14.2165 23.2017 14.1265 23.3464 13.7125C23.4911 13.2985 23.5128 12.9169 23.8745 12.7117C24.2363 12.5065 24.9597 12.2797 24.9597 11.5201C24.9597 10.7605 24.3846 11.0125 24.1784 10.7641C23.8998 10.4257 23.9469 10.1737 23.2994 10.0441C22.6518 9.91446 22.4999 9.88926 22.395 9.46086C22.2901 9.03246 22.1888 8.52126 21.516 8.60766C20.8432 8.69406 20.6949 8.50326 20.3982 7.99566C20.1812 7.61766 19.9461 7.25766 19.5481 7.21086C19.3093 7.19275 19.0779 7.12038 18.8715 6.99931C18.6652 6.87823 18.4895 6.71168 18.358 6.51246C18.0876 6.03413 17.6499 5.6715 17.1281 5.49366C16.6543 5.36046 16.0429 5.45046 15.7716 4.64406C15.5003 3.83766 14.6032 4.02846 14.4694 3.78726C14.3355 3.54606 14.1076 2.63886 13.3842 2.80086C12.6607 2.96286 12.7439 3.90246 12.7439 3.90246C12.6209 4.75566 12.2628 4.57926 11.8576 4.84566C11.4525 5.11206 11.4959 5.13366 11.3042 5.64486C11.1125 6.15606 10.7543 6.18126 10.3094 6.30006C9.86447 6.41886 9.81021 6.79326 9.67998 7.20006C9.54976 7.60686 9.31825 7.61406 8.87331 7.96686C8.42837 8.31966 8.38497 8.43126 8.27283 9.04686C8.16069 9.66246 7.91109 9.57606 7.54935 9.83166C7.18762 10.0873 7.12251 10.3861 6.95972 10.8289C6.79694 11.2717 6.46415 11.3149 6.17114 11.4769C6.03511 11.5647 5.92233 11.6838 5.84237 11.8242C5.7624 11.9645 5.71759 12.122 5.71173 12.2833C5.71173 12.5533 5.50193 12.7441 5.13657 12.9673C4.77122 13.1905 4.49268 13.6873 5.10402 13.9681C5.71535 14.2489 5.7877 14.2741 6.14943 14.9113C6.51117 15.5485 6.80418 15.4477 7.44083 15.6529C8.07749 15.8581 7.85683 15.9157 8.25112 16.4701C8.64542 17.0245 9.00353 16.9453 9.50273 16.9993C10.0019 17.0533 10.2262 17.2405 10.5879 17.9101C10.9497 18.5797 11.1812 18.4681 11.7744 18.5329C12.3677 18.5977 12.4979 18.7021 12.7403 19.3393C12.8363 19.6 13.0107 19.825 13.2399 19.9835C13.4691 20.142 13.7418 20.2263 14.0208 20.2249C14.5092 20.2465 14.7443 20.0953 14.9794 20.8081C15.2145 21.5209 16.6217 22.1725 16.8279 21.4993C17.0341 20.8261 17.3922 20.9521 17.678 20.7793C18.5461 20.2753 17.9312 19.6669 18.6655 19.3321Z",
    fill: "url(#paint85_radial_41_893)"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8718 19.0295C19.6893 18.6695 19.465 17.8847 20.0547 17.5463C20.9337 17.1287 20.7384 16.2467 21.1724 15.9731C21.6065 15.6995 21.9466 15.7355 22.1347 15.1055C22.2323 14.7887 22.2613 14.4359 22.5832 14.2415C22.9052 14.0471 23.3067 13.9571 23.4297 13.5575C23.5527 13.1579 23.5816 12.7799 23.9614 12.5819C24.3413 12.3839 24.996 12.1607 25.0032 11.4083C25.0105 10.6559 24.4462 10.9187 24.2436 10.6883C23.9723 10.3607 24.0157 10.1123 23.3899 9.99355C22.7641 9.87475 22.6085 9.84595 22.5073 9.42475C22.406 9.00355 22.3119 8.51035 21.6499 8.59675C20.988 8.68315 20.8541 8.49235 20.5647 7.99915C20.3513 7.63915 20.127 7.27915 19.7364 7.23955C19.5041 7.22132 19.2791 7.15055 19.0785 7.03264C18.8779 6.91473 18.707 6.75278 18.5788 6.55915C18.3171 6.0918 17.8904 5.73774 17.3814 5.56555C16.9184 5.43235 16.3396 5.52595 16.0647 4.74115C15.7898 3.95635 14.9216 4.14715 14.8023 3.91315C14.6829 3.67915 14.4405 2.79715 13.7532 2.95195C13.0659 3.10675 13.131 4.03195 13.131 4.03195C13.0225 4.83835 12.6608 4.67995 12.2665 4.92835C11.8722 5.17675 11.9265 5.20915 11.7275 5.70595C11.5286 6.20275 11.1921 6.22795 10.7581 6.34315C10.324 6.45835 10.2733 6.83995 10.1467 7.22155C10.0201 7.60315 9.78499 7.62115 9.36175 7.96315C8.93852 8.30515 8.88788 8.41675 8.77574 8.99995C8.6636 9.58315 8.41401 9.51835 8.08121 9.76315C7.74841 10.0079 7.66521 10.3031 7.50966 10.7387C7.35412 11.1743 7.02494 11.2103 6.73917 11.3651C6.60716 11.452 6.49769 11.5687 6.41973 11.7057C6.34176 11.8428 6.29752 11.9962 6.29061 12.1535C6.29061 12.4127 6.08804 12.5999 5.73354 12.8195C5.37904 13.0391 5.10412 13.5395 5.70098 13.7915C6.29785 14.0435 6.3304 14.0903 6.68129 14.7131C7.03217 15.3359 7.31794 15.2351 7.93651 15.4331C8.55508 15.6311 8.34166 15.6923 8.7251 16.2323C9.10854 16.7723 9.44857 16.6931 9.94415 16.7435C10.4397 16.7939 10.6676 16.9775 11.0294 17.6291C11.3911 18.2807 11.6081 18.1763 12.1869 18.2375C12.7657 18.2987 12.9104 18.4031 13.1274 19.0223C13.2206 19.2758 13.3901 19.4945 13.6128 19.6485C13.8355 19.8025 14.1006 19.8843 14.3718 19.8827C14.8493 19.9079 15.0953 19.7603 15.3051 20.4515C15.5149 21.1427 16.904 21.7799 17.1138 21.1247C17.3236 20.4695 17.6636 20.5919 17.9421 20.4299C18.7597 19.9475 18.1628 19.3535 18.8718 19.0295Z",
    fill: "url(#paint86_radial_41_893)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M13.4965 8.91354C13.4116 9.12269 13.2663 9.3021 13.079 9.42912C12.8917 9.55614 12.6708 9.62507 12.4442 9.6272C12.2175 9.62933 11.9953 9.56456 11.8056 9.44109C11.6159 9.31761 11.4673 9.14096 11.3784 8.93344C11.2896 8.72593 11.2645 8.49686 11.3064 8.27517C11.3483 8.05349 11.4552 7.84913 11.6137 7.6879C11.7723 7.52668 11.9752 7.41582 12.197 7.36934C12.4188 7.32286 12.6495 7.34283 12.8599 7.42674C13.1421 7.54031 13.3675 7.76056 13.4869 8.03924C13.6062 8.31792 13.6097 8.63231 13.4965 8.91354Z",
    fill: "url(#paint87_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M15.2473 6.87596C15.1638 7.08637 15.0192 7.26732 14.8321 7.39581C14.645 7.52431 14.4237 7.59454 14.1964 7.5976C13.9691 7.60066 13.746 7.53641 13.5554 7.413C13.3649 7.28959 13.2155 7.11259 13.1262 6.9045C13.037 6.69641 13.0119 6.46662 13.0542 6.24431C13.0965 6.022 13.2042 5.81722 13.3636 5.65597C13.5231 5.49473 13.7272 5.3843 13.9498 5.33871C14.1725 5.29313 14.4038 5.31444 14.6143 5.39996C14.8944 5.51275 15.1183 5.73134 15.2369 6.00794C15.3555 6.28453 15.3593 6.59662 15.2473 6.87596Z",
    fill: "url(#paint88_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M11.5757 11.0412C11.491 11.2516 11.3456 11.4322 11.1577 11.5603C10.9699 11.6883 10.7481 11.758 10.5204 11.7605C10.2927 11.763 10.0695 11.6982 9.87881 11.5743C9.68818 11.4504 9.53877 11.273 9.44951 11.0646C9.36025 10.8561 9.33515 10.626 9.3774 10.4033C9.41965 10.1807 9.52734 9.9755 9.68683 9.8138C9.84633 9.65209 10.0505 9.54113 10.2734 9.49496C10.4963 9.44879 10.7279 9.4695 10.939 9.55444C11.079 9.61029 11.2066 9.69309 11.3144 9.79809C11.4223 9.9031 11.5082 10.0282 11.5674 10.1664C11.6265 10.3045 11.6577 10.4529 11.6591 10.603C11.6605 10.7531 11.6322 10.902 11.5757 11.0412Z",
    fill: "url(#paint89_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M9.64741 13.5C9.56251 13.7091 9.41723 13.8885 9.22992 14.0155C9.04261 14.1426 8.82168 14.2115 8.59503 14.2136C8.36838 14.2158 8.14618 14.151 7.9565 14.0275C7.76681 13.904 7.61815 13.7274 7.52929 13.5199C7.44044 13.3124 7.41536 13.0833 7.45725 12.8616C7.49913 12.6399 7.60609 12.4356 7.76461 12.2743C7.92314 12.1131 8.12611 12.0022 8.34791 11.9558C8.5697 11.9093 8.80036 11.9293 9.01076 12.0132C9.29232 12.1275 9.51716 12.3478 9.63637 12.6262C9.75559 12.9047 9.75956 13.2187 9.64741 13.5Z",
    fill: "url(#paint90_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M16.2783 10.908C16.1934 11.1172 16.0481 11.2966 15.8608 11.4236C15.6735 11.5506 15.4525 11.6196 15.2259 11.6217C14.9992 11.6238 14.777 11.5591 14.5874 11.4356C14.3977 11.3121 14.249 11.1355 14.1602 10.9279C14.0713 10.7204 14.0462 10.4914 14.0881 10.2697C14.13 10.048 14.2369 9.84363 14.3955 9.68241C14.554 9.52118 14.757 9.41033 14.9788 9.36385C15.2006 9.31737 15.4312 9.33734 15.6416 9.42125C15.7817 9.4771 15.9092 9.55989 16.0171 9.6649C16.1249 9.7699 16.2108 9.89505 16.27 10.0332C16.3291 10.1713 16.3603 10.3197 16.3617 10.4698C16.3631 10.6199 16.3348 10.7688 16.2783 10.908Z",
    fill: "url(#paint91_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M18.0107 8.95319C17.9266 9.16239 17.7822 9.34214 17.5957 9.46979C17.4091 9.59743 17.1887 9.66726 16.9624 9.67047C16.736 9.67368 16.5137 9.61013 16.3236 9.48782C16.1334 9.36552 15.9839 9.18994 15.8939 8.9832C15.8039 8.77647 15.7773 8.54784 15.8177 8.32613C15.858 8.10442 15.9633 7.89955 16.1205 7.73734C16.2776 7.57513 16.4795 7.46284 16.7006 7.41462C16.9218 7.3664 17.1523 7.38442 17.3632 7.46639C17.5042 7.5212 17.6329 7.60324 17.7419 7.7078C17.8509 7.81235 17.938 7.93734 17.9982 8.07556C18.0584 8.21378 18.0905 8.3625 18.0926 8.51313C18.0948 8.66376 18.0669 8.81332 18.0107 8.95319Z",
    fill: "url(#paint92_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M14.3139 12.96C14.2287 13.1691 14.0831 13.3484 13.8956 13.4752C13.708 13.602 13.4869 13.6706 13.2602 13.6724C13.0334 13.6741 12.8113 13.609 12.6217 13.4851C12.4322 13.3612 12.2838 13.1842 12.1954 12.9765C12.1069 12.7687 12.0823 12.5395 12.1247 12.3178C12.1671 12.0961 12.2746 11.8919 12.4336 11.731C12.5926 11.5702 12.7959 11.4598 13.0179 11.4139C13.2399 11.368 13.4706 11.3886 13.6809 11.4732C13.8206 11.5293 13.9478 11.6124 14.0552 11.7175C14.1627 11.8227 14.2482 11.9479 14.307 12.086C14.3658 12.2241 14.3967 12.3723 14.3979 12.5223C14.399 12.6722 14.3705 12.821 14.3139 12.96Z",
    fill: "url(#paint93_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M12.5014 15.4799C12.4165 15.6891 12.2712 15.8685 12.0839 15.9955C11.8966 16.1225 11.6757 16.1915 11.449 16.1936C11.2224 16.1957 11.0002 16.131 10.8105 16.0075C10.6208 15.884 10.4722 15.7074 10.3833 15.4998C10.2944 15.2923 10.2694 15.0633 10.3113 14.8416C10.3531 14.6199 10.4601 14.4155 10.6186 14.2543C10.7771 14.0931 10.9801 13.9822 11.2019 13.9357C11.4237 13.8893 11.6544 13.9092 11.8648 13.9931C12.0048 14.049 12.1324 14.1318 12.2402 14.2368C12.348 14.3418 12.434 14.4669 12.4931 14.6051C12.5523 14.7432 12.5834 14.8916 12.5849 15.0417C12.5863 15.1918 12.5579 15.3407 12.5014 15.4799Z",
    fill: "url(#paint94_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M18.7417 12.6396C18.6579 12.8496 18.5133 13.0302 18.3263 13.1583C18.1393 13.2865 17.9182 13.3565 17.6912 13.3594C17.4641 13.3624 17.2413 13.2983 17.051 13.1751C16.8606 13.0519 16.7113 12.8753 16.6219 12.6676C16.5325 12.4599 16.5071 12.2304 16.5489 12.0083C16.5907 11.7862 16.6978 11.5814 16.8566 11.42C17.0155 11.2585 17.2189 11.1476 17.4412 11.1013C17.6634 11.0551 17.8945 11.0755 18.1051 11.16C18.3855 11.2737 18.6096 11.4927 18.7288 11.7697C18.8479 12.0467 18.8526 12.3593 18.7417 12.6396Z",
    fill: "url(#paint95_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M20.478 10.6452C20.3931 10.8544 20.2478 11.0338 20.0605 11.1608C19.8732 11.2878 19.6522 11.3568 19.4256 11.3589C19.1989 11.361 18.9767 11.2963 18.7871 11.1728C18.5974 11.0493 18.4487 10.8726 18.3599 10.6651C18.271 10.4576 18.2459 10.2285 18.2878 10.0069C18.3297 9.78518 18.4367 9.58082 18.5952 9.41959C18.7537 9.25837 18.9567 9.14751 19.1785 9.10103C19.4003 9.05455 19.6309 9.07452 19.8413 9.15843C20.1235 9.272 20.349 9.49225 20.4683 9.77093C20.5876 10.0496 20.5911 10.364 20.478 10.6452Z",
    fill: "url(#paint96_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M16.7302 14.7601C16.6458 14.9696 16.5009 15.1496 16.3137 15.2772C16.1266 15.4048 15.9056 15.4742 15.6788 15.4768C15.4519 15.4793 15.2294 15.4149 15.0394 15.2916C14.8493 15.1682 14.7004 14.9916 14.6112 14.784C14.5221 14.5763 14.4969 14.3471 14.5387 14.1252C14.5806 13.9033 14.6876 13.6987 14.8463 13.5374C15.005 13.376 15.2082 13.2652 15.4302 13.2188C15.6522 13.1724 15.8831 13.1926 16.0936 13.2769C16.3755 13.3897 16.6009 13.6092 16.7203 13.8873C16.8396 14.1654 16.8432 14.4793 16.7302 14.7601Z",
    fill: "url(#paint97_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M14.8818 17.172C14.7969 17.3811 14.6516 17.5605 14.4643 17.6875C14.277 17.8146 14.0561 17.8835 13.8294 17.8856C13.6028 17.8878 13.3806 17.823 13.1909 17.6995C13.0012 17.576 12.8525 17.3994 12.7637 17.1919C12.6748 16.9843 12.6497 16.7553 12.6916 16.5336C12.7335 16.3119 12.8405 16.1075 12.999 15.9463C13.1575 15.7851 13.3605 15.6742 13.5823 15.6278C13.8041 15.5813 14.0347 15.6013 14.2451 15.6852C14.5273 15.7987 14.7528 16.019 14.8721 16.2977C14.9914 16.5763 14.9949 16.8907 14.8818 17.172Z",
    fill: "url(#paint98_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M21.0927 14.2884C21.0075 14.4976 20.862 14.6769 20.6744 14.8037C20.4868 14.9305 20.2657 14.9991 20.039 15.0009C19.8122 15.0026 19.5901 14.9375 19.4005 14.8136C19.211 14.6897 19.0626 14.5127 18.9742 14.3049C18.8857 14.0972 18.8611 13.868 18.9035 13.6463C18.9459 13.4246 19.0534 13.2204 19.2124 13.0595C19.3714 12.8986 19.5747 12.7883 19.7967 12.7424C20.0188 12.6965 20.2494 12.7171 20.4597 12.8016C20.5997 12.8574 20.7272 12.9403 20.8349 13.0453C20.9426 13.1504 21.0284 13.2757 21.0872 13.4139C21.1461 13.5521 21.1768 13.7005 21.1778 13.8506C21.1787 14.0007 21.1498 14.1495 21.0927 14.2884Z",
    fill: "url(#paint99_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M22.7895 12.3192C22.7049 12.5296 22.5595 12.7102 22.3716 12.8382C22.1838 12.9663 21.962 13.0359 21.7343 13.0384C21.5066 13.0409 21.2833 12.9761 21.0927 12.8522C20.902 12.7284 20.7526 12.551 20.6634 12.3425C20.5741 12.1341 20.549 11.9039 20.5913 11.6813C20.6335 11.4586 20.7412 11.2535 20.9007 11.0917C21.0602 10.93 21.2643 10.8191 21.4872 10.7729C21.7101 10.7267 21.9418 10.7474 22.1529 10.8324C22.2929 10.8882 22.4205 10.971 22.5283 11.076C22.6361 11.1811 22.7221 11.3062 22.7812 11.4443C22.8404 11.5824 22.8715 11.7308 22.873 11.8809C22.8744 12.0311 22.846 12.18 22.7895 12.3192Z",
    fill: "url(#paint100_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M19.0854 16.4232C19.0008 16.6336 18.8554 16.8142 18.6675 16.9422C18.4797 17.0703 18.2578 17.1399 18.0302 17.1424C17.8025 17.1449 17.5792 17.0801 17.3886 16.9562C17.1979 16.8324 17.0485 16.655 16.9593 16.4465C16.87 16.2381 16.8449 16.0079 16.8872 15.7853C16.9294 15.5626 17.0371 15.3575 17.1966 15.1958C17.3561 15.0341 17.5602 14.9231 17.7831 14.8769C18.006 14.8308 18.2377 14.8515 18.4488 14.9364C18.5888 14.9923 18.7164 15.075 18.8242 15.1801C18.932 15.2851 19.018 15.4102 19.0771 15.5483C19.1363 15.6864 19.1674 15.8348 19.1689 15.9849C19.1703 16.1351 19.1419 16.284 19.0854 16.4232Z",
    fill: "url(#paint101_radial_41_893)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M17.3093 18.72C17.2246 18.9296 17.0794 19.1094 16.892 19.2368C16.7046 19.3642 16.4834 19.4333 16.2565 19.4355C16.0296 19.4377 15.8071 19.3729 15.6172 19.2492C15.4273 19.1254 15.2786 18.9484 15.1899 18.7406C15.1012 18.5327 15.0764 18.3033 15.1188 18.0814C15.1611 17.8595 15.2687 17.6551 15.4279 17.4941C15.587 17.3331 15.7906 17.2227 16.0128 17.1769C16.2351 17.1311 16.4659 17.152 16.6763 17.2368C16.8158 17.2927 16.943 17.3754 17.0504 17.4802C17.1578 17.585 17.2433 17.7099 17.3022 17.8477C17.361 17.9855 17.3919 18.1334 17.3931 18.2831C17.3943 18.4328 17.3658 18.5813 17.3093 18.72Z",
    fill: "url(#paint102_radial_41_893)"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4947 6.65635C14.4626 6.73426 14.4009 6.79646 14.3231 6.82947C14.2452 6.86248 14.1574 6.86366 14.0787 6.83275C14.0397 6.81736 14.0041 6.79433 13.9741 6.76504C13.9441 6.73575 13.9203 6.70078 13.9042 6.66219C13.888 6.62361 13.8797 6.58219 13.8799 6.54038C13.88 6.49857 13.8886 6.45721 13.9051 6.41875C13.939 6.34424 14.0006 6.28568 14.0769 6.25531C14.1532 6.22494 14.2383 6.22513 14.3145 6.25582C14.3907 6.28652 14.452 6.34536 14.4856 6.42001C14.5192 6.49466 14.5224 6.57935 14.4947 6.65635Z",
    fill: "url(#paint103_radial_41_893)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7765 8.63995C12.7533 8.69829 12.7132 8.74847 12.6614 8.78412C12.6095 8.81978 12.5482 8.83931 12.4851 8.84023C12.4221 8.84115 12.3602 8.82343 12.3073 8.78931C12.2544 8.75519 12.2129 8.7062 12.188 8.64857C12.1631 8.59093 12.1559 8.52723 12.1675 8.46555C12.179 8.40388 12.2087 8.34699 12.2527 8.30211C12.2968 8.25723 12.3532 8.22637 12.4149 8.21345C12.4766 8.20054 12.5407 8.20614 12.5992 8.22955C12.6772 8.26078 12.7397 8.32147 12.7729 8.39836C12.8061 8.47526 12.8074 8.56211 12.7765 8.63995Z",
    fill: "url(#paint104_radial_41_893)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8523 10.692C10.828 10.7487 10.7875 10.7969 10.7358 10.8308C10.6841 10.8647 10.6235 10.8826 10.5616 10.8824C10.4997 10.8821 10.4392 10.8638 10.3878 10.8295C10.3363 10.7953 10.2962 10.7467 10.2723 10.6898C10.2485 10.633 10.242 10.5704 10.2537 10.5099C10.2654 10.4494 10.2948 10.3937 10.3382 10.3498C10.3816 10.3058 10.437 10.2755 10.4975 10.2628C10.5581 10.25 10.6211 10.2553 10.6786 10.278C10.7177 10.2934 10.7533 10.3164 10.7832 10.3457C10.8132 10.375 10.837 10.41 10.8532 10.4485C10.8694 10.4871 10.8776 10.5285 10.8775 10.5704C10.8773 10.6122 10.8687 10.6535 10.8523 10.692Z",
    fill: "url(#paint105_radial_41_893)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94932 13.1113C8.92614 13.1696 8.88608 13.2198 8.83421 13.2554C8.78234 13.2911 8.72101 13.3106 8.65797 13.3115C8.59494 13.3125 8.53305 13.2947 8.48015 13.2606C8.42725 13.2265 8.38573 13.1775 8.36083 13.1199C8.33594 13.0622 8.3288 12.9985 8.34032 12.9369C8.35185 12.8752 8.38151 12.8183 8.42556 12.7734C8.46961 12.7285 8.52605 12.6977 8.58774 12.6848C8.64943 12.6718 8.71358 12.6774 8.77207 12.7009C8.8501 12.7321 8.91253 12.7928 8.94575 12.8697C8.97896 12.9466 8.98024 13.0334 8.94932 13.1113Z",
    fill: "url(#paint106_radial_41_893)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2659 8.64005C17.2345 8.7177 17.1735 8.77984 17.0963 8.81289C17.019 8.84594 16.9317 8.84722 16.8535 8.81645C16.7752 8.78447 16.7127 8.72311 16.6796 8.64563C16.6464 8.56815 16.6452 8.48079 16.6763 8.40245C16.7077 8.3248 16.7686 8.26266 16.8459 8.2296C16.9232 8.19655 17.0104 8.19527 17.0887 8.22605C17.1669 8.25802 17.2294 8.31939 17.2626 8.39687C17.2958 8.47435 17.297 8.56171 17.2659 8.64005Z",
    fill: "url(#paint107_radial_41_893)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5545 10.6128C15.5217 10.6901 15.4598 10.7514 15.382 10.7837C15.3042 10.816 15.2168 10.8167 15.1385 10.7856C15.0605 10.7544 14.998 10.6937 14.9648 10.6168C14.9316 10.5399 14.9303 10.453 14.9613 10.3752C14.9769 10.3364 15.0001 10.3011 15.0295 10.2713C15.0589 10.2414 15.0939 10.2176 15.1326 10.2012C15.1712 10.1849 15.2127 10.1762 15.2547 10.1758C15.2966 10.1754 15.3383 10.1832 15.3773 10.1988C15.4162 10.2144 15.4517 10.2375 15.4817 10.2667C15.5117 10.296 15.5356 10.3308 15.552 10.3693C15.5685 10.4077 15.5772 10.449 15.5776 10.4908C15.578 10.5326 15.5702 10.574 15.5545 10.6128Z",
    fill: "url(#paint108_radial_41_893)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6121 12.672C13.5977 12.7122 13.5752 12.749 13.546 12.7803C13.5169 12.8117 13.4817 12.8368 13.4425 12.8542C13.4034 12.8717 13.3611 12.8811 13.3182 12.8818C13.2754 12.8826 13.2328 12.8748 13.193 12.8587C13.1532 12.8427 13.1171 12.8189 13.0869 12.7886C13.0566 12.7584 13.0328 12.7223 13.0169 12.6827C13.001 12.6431 12.9933 12.6006 12.9942 12.558C12.9952 12.5153 13.0048 12.4733 13.0225 12.4344C13.0564 12.3599 13.118 12.3013 13.1943 12.2709C13.2706 12.2406 13.3558 12.2408 13.4319 12.2714C13.5081 12.3021 13.5694 12.361 13.603 12.4356C13.6366 12.5103 13.6399 12.595 13.6121 12.672Z",
    fill: "url(#paint109_radial_41_893)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M11.72 15.0948C11.6872 15.1721 11.6254 15.2337 11.5478 15.2666C11.4702 15.2995 11.3828 15.3011 11.304 15.2712C11.2264 15.2385 11.1647 15.1769 11.1323 15.0994C11.0998 15.022 11.0991 14.9351 11.1304 14.8572C11.1618 14.7795 11.2228 14.7174 11.3 14.6843C11.3773 14.6513 11.4646 14.65 11.5428 14.6808C11.6211 14.7127 11.6836 14.7741 11.7167 14.8516C11.7499 14.9291 11.7511 15.0164 11.72 15.0948Z",
    fill: "url(#paint110_radial_41_893)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6855 10.3644C19.6533 10.4423 19.5917 10.5045 19.5138 10.5375C19.436 10.5706 19.3482 10.5717 19.2695 10.5408C19.2113 10.5172 19.1614 10.477 19.1261 10.4252C19.0909 10.3735 19.0718 10.3125 19.0713 10.25C19.0708 10.1874 19.0889 10.1261 19.1234 10.0738C19.1578 10.0215 19.207 9.98053 19.2648 9.95602C19.3226 9.9315 19.3865 9.92457 19.4482 9.93608C19.51 9.94759 19.5669 9.97704 19.6119 10.0207C19.6569 10.0644 19.6879 10.1203 19.701 10.1815C19.7141 10.2427 19.7087 10.3063 19.6855 10.3644Z",
    fill: "url(#paint111_radial_41_893)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9709 12.3373C17.9388 12.4152 17.8772 12.4774 17.7993 12.5104C17.7215 12.5434 17.6337 12.5446 17.5549 12.5136C17.515 12.4996 17.4783 12.4778 17.447 12.4494C17.4156 12.421 17.3903 12.3868 17.3724 12.3485C17.3546 12.3103 17.3446 12.2689 17.343 12.2268C17.3414 12.1847 17.3483 12.1427 17.3632 12.1032C17.3944 12.025 17.4556 11.9622 17.5332 11.9288C17.6109 11.8954 17.6987 11.894 17.7774 11.9251C17.8561 11.9561 17.9191 12.0169 17.9527 12.0942C17.9863 12.1715 17.9877 12.259 17.9565 12.3373H17.9709Z",
    fill: "url(#paint112_radial_41_893)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0321 14.4001C16.0176 14.4402 15.9951 14.4771 15.966 14.5084C15.9368 14.5397 15.9016 14.5649 15.8625 14.5823C15.8233 14.5998 15.781 14.6091 15.7382 14.6099C15.6953 14.6107 15.6527 14.6028 15.6129 14.5868C15.5732 14.5708 15.5371 14.5469 15.5068 14.5167C15.4765 14.4864 15.4527 14.4504 15.4368 14.4108C15.4209 14.3712 15.4132 14.3287 15.4141 14.286C15.4151 14.2434 15.4247 14.2013 15.4424 14.1625C15.4575 14.1237 15.4803 14.0884 15.5094 14.0586C15.5385 14.0288 15.5733 14.0051 15.6118 13.989C15.6503 13.9729 15.6916 13.9646 15.7334 13.9647C15.7751 13.9648 15.8164 13.9733 15.8548 13.9897C15.9328 14.0209 15.9953 14.0816 16.0285 14.1585C16.0617 14.2354 16.063 14.3222 16.0321 14.4001Z",
    fill: "url(#paint113_radial_41_893)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M14.14 16.8191C14.1079 16.8971 14.0463 16.9592 13.9684 16.9923C13.8906 17.0253 13.8028 17.0264 13.724 16.9955C13.6659 16.9719 13.616 16.9317 13.5807 16.88C13.5455 16.8282 13.5264 16.7672 13.5259 16.7047C13.5254 16.6421 13.5435 16.5809 13.578 16.5285C13.6124 16.4762 13.6616 16.4352 13.7194 16.4107C13.7772 16.3862 13.841 16.3793 13.9028 16.3908C13.9646 16.4023 14.0215 16.4318 14.0665 16.4754C14.1115 16.5191 14.1425 16.575 14.1556 16.6362C14.1686 16.6974 14.1632 16.761 14.14 16.8191Z",
    fill: "url(#paint114_radial_41_893)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0336 11.988C22.0181 12.0268 21.995 12.0623 21.9656 12.0922C21.9362 12.1222 21.9012 12.146 21.8625 12.1624C21.8239 12.1788 21.7823 12.1875 21.7403 12.1878C21.6982 12.1881 21.6565 12.1802 21.6176 12.1644C21.5594 12.1408 21.5095 12.1005 21.4743 12.0488C21.439 11.997 21.4199 11.936 21.4194 11.8735C21.4189 11.811 21.4371 11.7497 21.4715 11.6974C21.5059 11.6451 21.5552 11.6041 21.613 11.5796C21.6708 11.555 21.7346 11.5481 21.7964 11.5596C21.8581 11.5711 21.9151 11.6006 21.9601 11.6442C22.005 11.6879 22.036 11.7439 22.0491 11.805C22.0622 11.8662 22.0568 11.9298 22.0336 11.988Z",
    fill: "url(#paint115_radial_41_893)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3152 13.9608C20.2838 14.0384 20.2229 14.1006 20.1456 14.1336C20.0683 14.1667 19.9811 14.168 19.9028 14.1372C19.8246 14.1052 19.7621 14.0439 19.7289 13.9664C19.6957 13.8889 19.6945 13.8015 19.7256 13.7232C19.7411 13.6848 19.7641 13.6498 19.7933 13.6202C19.8224 13.5907 19.8572 13.5672 19.8955 13.5512C19.9339 13.5351 19.9751 13.5267 20.0167 13.5266C20.0583 13.5265 20.0995 13.5346 20.138 13.5504C20.216 13.5816 20.2784 13.6423 20.3116 13.7192C20.3449 13.7961 20.3461 13.883 20.3152 13.9608Z",
    fill: "url(#paint116_radial_41_893)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3798 16.02C18.3643 16.0589 18.3412 16.0943 18.3118 16.1243C18.2825 16.1542 18.2474 16.1781 18.2088 16.1945C18.1701 16.2109 18.1285 16.2195 18.0865 16.2198C18.0444 16.2202 18.0028 16.2122 17.9638 16.1964C17.9249 16.1814 17.8894 16.1587 17.8594 16.1298C17.8295 16.1008 17.8057 16.0662 17.7895 16.0279C17.7733 15.9896 17.765 15.9484 17.7651 15.9069C17.7653 15.8653 17.7738 15.8242 17.7902 15.786C17.8255 15.7144 17.8867 15.6586 17.9616 15.6299C18.0364 15.6012 18.1194 15.6017 18.1939 15.6313C18.2684 15.6609 18.3289 15.7173 18.3634 15.7894C18.3979 15.8615 18.4037 15.9438 18.3798 16.02Z",
    fill: "url(#paint117_radial_41_893)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4879 18.4427C16.4563 18.521 16.3947 18.5836 16.3167 18.6167C16.2386 18.6498 16.1506 18.6507 16.072 18.6191C15.9933 18.5876 15.9304 18.5263 15.8972 18.4487C15.8639 18.371 15.863 18.2834 15.8947 18.2051C15.9264 18.1269 15.988 18.0643 16.066 18.0312C16.144 17.9981 16.232 17.9972 16.3107 18.0287C16.3894 18.0603 16.4522 18.1216 16.4855 18.1992C16.5187 18.2769 16.5196 18.3645 16.4879 18.4427Z",
    fill: "url(#paint118_radial_41_893)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.6667 5.13355C15.6667 5.13355 16.1803 5.93275 16.694 5.93275C17.3379 5.93275 17.4392 5.84635 17.7792 6.56275C18.1193 7.27915 17.5984 7.64275 17.0087 7.66795C16.4191 7.69315 15.7065 8.81635 15.0517 8.99995C14.397 9.18355 13.9665 7.99195 14.5344 7.55995C14.7788 7.38338 14.9602 7.13398 15.0526 6.8479C15.145 6.56181 15.1434 6.25389 15.0481 5.96875C14.8853 5.46475 15.2434 4.57915 15.6667 5.13355Z",
    fill: "url(#paint119_radial_41_893)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.9152 9.00001C9.9152 9.00001 10.8268 7.69681 11.4128 8.64001C11.9988 9.58321 12.4329 9.30601 13.0225 9.60841C13.6121 9.91081 14.5744 10.5516 14.7842 11.1456C14.994 11.7396 14.6359 12.3084 13.9594 11.9088C13.283 11.5092 13.3481 11.9844 12.715 12.4344C12.082 12.8844 10.8051 12.6972 11.1849 11.7576C11.5647 10.818 11.865 10.2348 11.467 9.95761C11.0691 9.68041 10.8449 9.59761 10.2335 9.97921C9.62219 10.3608 9.31471 9.51841 9.9152 9.00001Z",
    fill: "url(#paint120_radial_41_893)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.4953 9.11517C16.4953 9.11517 17.6058 9.25557 17.9965 9.91797C18.3871 10.5804 18.8176 10.638 18.7199 11.1672C18.6223 11.6964 18.2352 11.7288 17.8084 11.6604C17.6993 11.6344 17.5852 11.6385 17.4783 11.6721C17.3714 11.7057 17.2756 11.7676 17.2013 11.8511C17.127 11.9347 17.0769 12.0368 17.0564 12.1465C17.0359 12.2562 17.0457 12.3694 17.0849 12.474C17.2404 13.0932 16.564 13.356 16.1154 13.2912C15.6669 13.2264 14.9253 12.42 15.486 11.7864C16.0467 11.1528 16.2674 10.4796 16.1299 10.0728C15.9924 9.66597 16.0503 9.08637 16.4953 9.11517Z",
    fill: "url(#paint121_radial_41_893)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.8312 15.8796C14.996 16.0514 15.0933 16.2765 15.1053 16.5137C15.1172 16.751 15.043 16.9846 14.8963 17.172C14.3754 17.892 14.4152 17.6112 13.6338 17.7912C12.8525 17.9712 13.5253 18.5904 13.5832 18.9648C13.641 19.3392 14.8348 19.5372 15.2254 18.9216C15.6161 18.306 15.7536 17.7984 16.2275 17.4816C16.7013 17.1648 17.215 16.9632 16.875 16.4016C16.5349 15.84 14.5671 14.5836 14.8312 15.8796Z",
    fill: "url(#paint122_radial_41_893)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.8431 8.94237C20.8431 8.94237 21.8306 8.58237 22.0549 9.28077C22.2792 9.97917 22.1019 9.88197 23.1003 10.2096C24.0987 10.5372 23.9395 11.016 23.6357 11.4012C23.3318 11.7864 22.6445 11.6928 22.337 11.2788C22.0296 10.8648 21.4182 10.7676 20.9805 10.62C20.5428 10.4724 20.7382 10.0548 20.6767 9.84597C20.6152 9.63717 20.6369 8.99997 20.8431 8.94237Z",
    fill: "url(#paint123_radial_41_893)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.7462 6.33595C13.7246 6.32736 13.7005 6.32765 13.6791 6.33677C13.6577 6.34588 13.6409 6.36307 13.6322 6.38455C13.6236 6.40603 13.6239 6.43005 13.6331 6.45132C13.6422 6.47258 13.6595 6.48936 13.6811 6.49795C13.7027 6.50654 13.7268 6.50625 13.7482 6.49714C13.7695 6.48802 13.7864 6.47083 13.795 6.44935C13.8037 6.42787 13.8034 6.40385 13.7942 6.38259C13.7851 6.36132 13.7678 6.34454 13.7462 6.33595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.9303 10.9944C13.9088 10.9879 13.8856 10.9896 13.8653 10.9991C13.8449 11.0087 13.8289 11.0254 13.8203 11.0461C13.8117 11.0668 13.8112 11.0899 13.8188 11.111C13.8264 11.132 13.8417 11.1495 13.8615 11.16C13.883 11.1665 13.9062 11.1648 13.9265 11.1552C13.9469 11.1457 13.9629 11.1289 13.9715 11.1082C13.98 11.0876 13.9806 11.0644 13.973 11.0434C13.9653 11.0223 13.9501 11.0049 13.9303 10.9944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.1373 11.268C18.1162 11.2634 18.0942 11.2664 18.0752 11.2765C18.0562 11.2866 18.0414 11.3031 18.0336 11.3231C18.0257 11.3431 18.0253 11.3652 18.0324 11.3854C18.0394 11.4057 18.0536 11.4228 18.0722 11.4336C18.0932 11.4382 18.1152 11.4352 18.1343 11.4251C18.1533 11.415 18.168 11.3985 18.1759 11.3785C18.1838 11.3585 18.1842 11.3364 18.1771 11.3161C18.17 11.2959 18.1559 11.2788 18.1373 11.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.9659 17.2404C18.9444 17.2338 18.9212 17.2355 18.9009 17.2451C18.8806 17.2547 18.8646 17.2714 18.856 17.2921C18.8474 17.3128 18.8469 17.3359 18.8545 17.3569C18.8621 17.378 18.8773 17.3955 18.8972 17.406C18.9187 17.4125 18.9419 17.4108 18.9622 17.4012C18.9825 17.3917 18.9985 17.3749 19.0071 17.3542C19.0157 17.3335 19.0162 17.3104 19.0086 17.2894C19.001 17.2683 18.9858 17.2508 18.9659 17.2404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.1285 12.9167C10.107 12.9102 10.0838 12.9119 10.0635 12.9215C10.0432 12.931 10.0272 12.9478 10.0186 12.9685C10.01 12.9892 10.0094 13.0123 10.0171 13.0333C10.0247 13.0544 10.0399 13.0719 10.0598 13.0823C10.0813 13.0889 10.1045 13.0872 10.1248 13.0776C10.1451 13.068 10.1611 13.0513 10.1697 13.0306C10.1783 13.0099 10.1788 12.9868 10.1712 12.9658C10.1636 12.9447 10.1484 12.9272 10.1285 12.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.9527 6.6383C15.9312 6.63178 15.908 6.63347 15.8877 6.64304C15.8674 6.6526 15.8514 6.66936 15.8428 6.69004C15.8342 6.71072 15.8337 6.73384 15.8413 6.75489C15.8489 6.77595 15.8641 6.79342 15.884 6.8039C15.9055 6.81042 15.9287 6.80873 15.949 6.79917C15.9693 6.7896 15.9853 6.77285 15.9939 6.75217C16.0025 6.73149 16.003 6.70837 15.9954 6.68731C15.9878 6.66626 15.9726 6.64879 15.9527 6.6383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3648 9.7559C16.3438 9.75128 16.3218 9.75428 16.3027 9.76438C16.2837 9.77448 16.269 9.79101 16.2611 9.81099C16.2532 9.83097 16.2528 9.85308 16.2599 9.87334C16.267 9.89361 16.2811 9.91069 16.2997 9.9215C16.3208 9.92613 16.3428 9.92313 16.3618 9.91303C16.3808 9.90293 16.3956 9.8864 16.4034 9.86642C16.4113 9.84644 16.4117 9.82433 16.4046 9.80406C16.3976 9.7838 16.3834 9.76672 16.3648 9.7559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9893 9.97551C10.9683 9.97088 10.9463 9.97389 10.9273 9.98399C10.9082 9.99409 10.8935 10.0106 10.8856 10.0306C10.8778 10.0506 10.8773 10.0727 10.8844 10.0929C10.8915 10.1132 10.9056 10.1303 10.9242 10.1411C10.9453 10.1457 10.9673 10.1427 10.9863 10.1326C11.0053 10.1225 11.0201 10.106 11.028 10.086C11.0358 10.066 11.0362 10.0439 11.0292 10.0237C11.0221 10.0034 11.008 9.98633 10.9893 9.97551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8111 13.68C13.7901 13.6753 13.768 13.6784 13.749 13.6885C13.73 13.6986 13.7152 13.7151 13.7074 13.7351C13.6995 13.755 13.6991 13.7772 13.7062 13.7974C13.7133 13.8177 13.7274 13.8348 13.746 13.8456C13.7671 13.8502 13.7891 13.8472 13.8081 13.8371C13.8271 13.827 13.8419 13.8105 13.8497 13.7905C13.8576 13.7705 13.858 13.7484 13.8509 13.7281C13.8439 13.7079 13.8297 13.6908 13.8111 13.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4122 13.464C18.3907 13.4575 18.3675 13.4592 18.3472 13.4687C18.3269 13.4783 18.3108 13.495 18.3023 13.5157C18.2937 13.5364 18.2931 13.5595 18.3008 13.5806C18.3084 13.6016 18.3236 13.6191 18.3435 13.6296C18.365 13.6361 18.3881 13.6344 18.4085 13.6249C18.4288 13.6153 18.4448 13.5985 18.4534 13.5779C18.462 13.5572 18.4625 13.534 18.4549 13.513C18.4473 13.4919 18.4321 13.4745 18.4122 13.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2086 14.5188C21.1871 14.5123 21.1639 14.514 21.1436 14.5235C21.1232 14.5331 21.1072 14.5499 21.0986 14.5705C21.0901 14.5912 21.0895 14.6143 21.0971 14.6354C21.1048 14.6564 21.12 14.6739 21.1398 14.6844C21.1614 14.6909 21.1845 14.6892 21.2049 14.6797C21.2252 14.6701 21.2412 14.6533 21.2498 14.6327C21.2584 14.612 21.2589 14.5889 21.2513 14.5678C21.2437 14.5468 21.2284 14.5293 21.2086 14.5188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6964 18.8892C17.6753 18.8846 17.6533 18.8876 17.6343 18.8977C17.6153 18.9078 17.6005 18.9243 17.5926 18.9443C17.5848 18.9643 17.5844 18.9864 17.5914 19.0066C17.5985 19.0269 17.6126 19.044 17.6313 19.0548C17.6523 19.0594 17.6743 19.0564 17.6933 19.0463C17.7124 19.0362 17.7271 19.0197 17.735 18.9997C17.7428 18.9797 17.7433 18.9576 17.7362 18.9374C17.7291 18.9171 17.715 18.9 17.6964 18.8892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6417 15.6887C15.6202 15.6822 15.597 15.6839 15.5767 15.6935C15.5564 15.703 15.5403 15.7198 15.5318 15.7405C15.5232 15.7611 15.5226 15.7843 15.5303 15.8053C15.5379 15.8264 15.5531 15.8438 15.573 15.8543C15.5945 15.8608 15.6176 15.8591 15.638 15.8496C15.6583 15.84 15.6743 15.8233 15.6829 15.8026C15.6915 15.7819 15.692 15.7588 15.6844 15.7377C15.6768 15.7167 15.6615 15.6992 15.6417 15.6887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91317 10.7999C8.89166 10.7934 8.86848 10.7951 8.84816 10.8047C8.82783 10.8142 8.81182 10.831 8.80324 10.8517C8.79465 10.8723 8.79412 10.8955 8.80174 10.9165C8.80935 10.9376 8.82458 10.955 8.84444 10.9655C8.86595 10.972 8.88912 10.9704 8.90945 10.9608C8.92977 10.9512 8.94579 10.9345 8.95437 10.9138C8.96295 10.8931 8.96349 10.87 8.95587 10.8489C8.94825 10.8279 8.93303 10.8104 8.91317 10.7999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.252 11.6352C12.231 11.6305 12.209 11.6336 12.1899 11.6437C12.1709 11.6538 12.1562 11.6703 12.1483 11.6903C12.1405 11.7102 12.14 11.7324 12.1471 11.7526C12.1542 11.7729 12.1683 11.79 12.1869 11.8008C12.208 11.8054 12.23 11.8024 12.249 11.7923C12.268 11.7822 12.2828 11.7657 12.2906 11.7457C12.2985 11.7257 12.2989 11.7036 12.2918 11.6833C12.2848 11.6631 12.2706 11.646 12.252 11.6352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.089 15.7103C10.0674 15.7012 10.0431 15.7011 10.0214 15.7098C9.9997 15.7186 9.98238 15.7356 9.97327 15.7571C9.96415 15.7786 9.96399 15.8028 9.97281 15.8244C9.98162 15.846 9.99871 15.8632 10.0203 15.8723C10.0419 15.8814 10.0662 15.8815 10.0879 15.8728C10.1096 15.864 10.1269 15.847 10.136 15.8255C10.1452 15.804 10.1453 15.7798 10.1365 15.7582C10.1277 15.7366 10.1106 15.7194 10.089 15.7103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1558 8.51758C20.1343 8.51106 20.1112 8.51275 20.0908 8.52231C20.0705 8.53188 20.0545 8.54863 20.0459 8.56931C20.0373 8.58999 20.0368 8.61311 20.0444 8.63417C20.052 8.65522 20.0673 8.67269 20.0871 8.68318C20.1086 8.6897 20.1318 8.68801 20.1521 8.67844C20.1724 8.66888 20.1885 8.65212 20.197 8.63144C20.2056 8.61076 20.2062 8.58764 20.1985 8.56659C20.1909 8.54554 20.1757 8.52806 20.1558 8.51758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2992 14.4504C12.1907 14.4072 12.122 14.5764 12.2305 14.616C12.252 14.6225 12.2752 14.6208 12.2955 14.6112C12.3158 14.6017 12.3318 14.5849 12.3404 14.5642C12.349 14.5435 12.3495 14.5204 12.3419 14.4994C12.3343 14.4783 12.3191 14.4608 12.2992 14.4504Z",
    fill: "white"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6929 13.2948C19.6853 13.292 19.6772 13.2907 19.6691 13.2909C19.661 13.2912 19.653 13.2931 19.6456 13.2964C19.6382 13.2997 19.6316 13.3045 19.626 13.3104C19.6205 13.3163 19.6162 13.3232 19.6133 13.3308C19.6105 13.3384 19.6091 13.3464 19.6094 13.3545C19.6097 13.3626 19.6116 13.3705 19.6149 13.3779C19.6183 13.3852 19.6231 13.3918 19.629 13.3974C19.6349 13.4029 19.6419 13.4072 19.6495 13.41C19.6648 13.4157 19.6818 13.4152 19.6968 13.4084C19.7117 13.4017 19.7233 13.3893 19.7291 13.374C19.7348 13.3587 19.7342 13.3418 19.7275 13.327C19.7207 13.3121 19.7082 13.3005 19.6929 13.2948Z",
    fill: "#C87100"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3245 9.80642C12.3103 9.80284 12.2952 9.80448 12.282 9.81102C12.2689 9.81757 12.2585 9.8286 12.2528 9.8421C12.2471 9.8556 12.2465 9.87068 12.251 9.88461C12.2556 9.89854 12.265 9.91039 12.2775 9.91802C12.2918 9.92159 12.3069 9.91995 12.32 9.91341C12.3332 9.90686 12.3436 9.89584 12.3492 9.88233C12.3549 9.86883 12.3556 9.85375 12.351 9.83982C12.3465 9.82589 12.3371 9.81404 12.3245 9.80642Z",
    fill: "#C87100"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0533 6.64923C14.0457 6.64615 14.0375 6.6446 14.0293 6.64465C14.0211 6.64471 14.013 6.64637 14.0055 6.64955C13.9902 6.65596 13.9781 6.66815 13.9719 6.68343C13.9656 6.6987 13.9658 6.71582 13.9722 6.73101C13.9786 6.7462 13.9909 6.75822 14.0062 6.76443C14.0216 6.77063 14.0388 6.77051 14.0541 6.7641C14.0693 6.75769 14.0814 6.7455 14.0876 6.73023C14.0939 6.71495 14.0938 6.69783 14.0873 6.68264C14.0809 6.66745 14.0686 6.65543 14.0533 6.64923Z",
    fill: "#C87100"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8619 12.8592C13.8465 12.853 13.8293 12.8531 13.8141 12.8595C13.7988 12.8659 13.7867 12.8781 13.7805 12.8934C13.7742 12.9087 13.7744 12.9258 13.7808 12.941C13.7872 12.9562 13.7995 12.9682 13.8148 12.9744C13.8224 12.9775 13.8306 12.979 13.8388 12.979C13.847 12.9789 13.8551 12.9772 13.8626 12.9741C13.8702 12.9709 13.8771 12.9663 13.8828 12.9604C13.8886 12.9546 13.8931 12.9477 13.8962 12.9402C13.8993 12.9326 13.9009 12.9245 13.9008 12.9164C13.9008 12.9082 13.8991 12.9001 13.8959 12.8926C13.8927 12.8851 13.8881 12.8783 13.8822 12.8725C13.8764 12.8668 13.8695 12.8623 13.8619 12.8592Z",
    fill: "#C87100"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4232 10.44C9.40931 10.4378 9.39508 10.4404 9.38289 10.4474C9.3707 10.4543 9.36128 10.4653 9.3562 10.4783C9.35112 10.4914 9.35069 10.5058 9.35499 10.5191C9.35928 10.5324 9.36804 10.5439 9.3798 10.5516C9.38746 10.5566 9.39616 10.5598 9.40525 10.561C9.41434 10.5623 9.42359 10.5615 9.43232 10.5587C9.44105 10.5559 9.44905 10.5512 9.45573 10.5449C9.4624 10.5387 9.46758 10.531 9.47089 10.5225C9.47421 10.514 9.47556 10.5048 9.47486 10.4957C9.47416 10.4866 9.47143 10.4778 9.46686 10.4699C9.46228 10.462 9.45599 10.4552 9.44844 10.45C9.44088 10.4448 9.43226 10.4414 9.4232 10.44Z",
    fill: "#C87100"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8873 15.3397C15.8797 15.3366 15.8715 15.335 15.8633 15.3351C15.8551 15.3351 15.847 15.3368 15.8394 15.34C15.8242 15.3464 15.8121 15.3586 15.8059 15.3739C15.7996 15.3891 15.7997 15.4062 15.8062 15.4214C15.8126 15.4366 15.8249 15.4486 15.8402 15.4549C15.8556 15.4611 15.8728 15.4609 15.888 15.4545C15.9033 15.4481 15.9154 15.4359 15.9216 15.4207C15.9279 15.4054 15.9277 15.3883 15.9213 15.3731C15.9148 15.3579 15.9026 15.3459 15.8873 15.3397Z",
    fill: "#C87100"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8926 17.6399C14.885 17.6369 14.8769 17.6353 14.8687 17.6354C14.8605 17.6354 14.8524 17.6371 14.8448 17.6403C14.8295 17.6467 14.8175 17.6589 14.8112 17.6741C14.805 17.6894 14.8051 17.7065 14.8116 17.7217C14.818 17.7369 14.8302 17.7489 14.8456 17.7551C14.861 17.7614 14.8781 17.7612 14.8934 17.7548C14.9087 17.7484 14.9208 17.7362 14.927 17.7209C14.9332 17.7057 14.9331 17.6886 14.9267 17.6734C14.9202 17.6582 14.908 17.6462 14.8926 17.6399Z",
    fill: "#C87100"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47759 15.4008C9.46224 15.3946 9.44504 15.3947 9.42977 15.4011C9.41451 15.4076 9.40243 15.4197 9.3962 15.435C9.38996 15.4503 9.39008 15.4674 9.39652 15.4826C9.40297 15.4978 9.41521 15.5098 9.43056 15.516C9.44591 15.5222 9.46311 15.5221 9.47837 15.5157C9.49364 15.5093 9.50571 15.4971 9.51195 15.4818C9.51819 15.4665 9.51807 15.4494 9.51163 15.4342C9.50518 15.419 9.49294 15.407 9.47759 15.4008Z",
    fill: "#C87100"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M11.753 12.654C11.7454 12.6509 11.7372 12.6494 11.729 12.6494C11.7208 12.6495 11.7127 12.6511 11.7052 12.6543C11.6976 12.6575 11.6908 12.6621 11.685 12.6679C11.6792 12.6737 11.6747 12.6806 11.6716 12.6882C11.6685 12.6957 11.6669 12.7038 11.667 12.712C11.667 12.7202 11.6687 12.7282 11.6719 12.7358C11.6751 12.7433 11.6798 12.7501 11.6856 12.7558C11.6914 12.7616 11.6984 12.7661 11.706 12.7692C11.7213 12.7754 11.7385 12.7753 11.7538 12.7689C11.769 12.7624 11.7811 12.7503 11.7873 12.735C11.7936 12.7197 11.7935 12.7026 11.787 12.6874C11.7806 12.6722 11.7683 12.6602 11.753 12.654Z",
    fill: "#C87100"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7245 17.64C15.7102 17.6365 15.6951 17.6381 15.6819 17.6446C15.6688 17.6512 15.6584 17.6622 15.6527 17.6757C15.647 17.6892 15.6464 17.7043 15.6509 17.7182C15.6555 17.7322 15.6649 17.744 15.6774 17.7516C15.685 17.7562 15.6935 17.7591 15.7022 17.7602C15.711 17.7612 15.72 17.7603 15.7284 17.7576C15.7368 17.7549 15.7445 17.7504 15.7511 17.7444C15.7576 17.7385 15.7627 17.7312 15.7662 17.7231C15.7696 17.7149 15.7712 17.7062 15.7709 17.6973C15.7706 17.6885 15.7684 17.6799 15.7644 17.672C15.7605 17.6641 15.7549 17.6572 15.748 17.6517C15.7411 17.6462 15.733 17.6422 15.7245 17.64Z",
    fill: "#C87100"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4317 19.0079C15.4163 19.0022 15.3993 19.0028 15.3844 19.0095C15.3695 19.0163 15.3578 19.0287 15.3521 19.0439C15.3463 19.0592 15.3469 19.0761 15.3537 19.091C15.3605 19.1059 15.3729 19.1174 15.3883 19.1231C15.4036 19.1289 15.4206 19.1283 15.4355 19.1215C15.4505 19.1148 15.4621 19.1024 15.4678 19.0871C15.4736 19.0719 15.473 19.0549 15.4662 19.0401C15.4594 19.0252 15.447 19.0137 15.4317 19.0079Z",
    fill: "#C87100"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0782 6.43316C12.0628 6.42695 12.0456 6.42707 12.0304 6.43348C12.0151 6.4399 12.003 6.45208 11.9968 6.46736C11.9905 6.48264 11.9907 6.49975 11.9971 6.51494C12.0036 6.53013 12.0158 6.54215 12.0311 6.54836C12.0465 6.55457 12.0637 6.55445 12.079 6.54804C12.0942 6.54162 12.1063 6.52944 12.1125 6.51416C12.1188 6.49888 12.1187 6.48177 12.1122 6.46658C12.1058 6.45139 12.0935 6.43937 12.0782 6.43316Z",
    fill: "#C87100"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0818 12.4164C21.0742 12.4118 21.0658 12.4089 21.057 12.4079C21.0482 12.4069 21.0393 12.4077 21.0308 12.4104C21.0224 12.4132 21.0147 12.4177 21.0082 12.4236C21.0016 12.4296 20.9965 12.4369 20.9931 12.445C20.9896 12.4531 20.988 12.4619 20.9883 12.4707C20.9886 12.4795 20.9908 12.4882 20.9948 12.496C20.9987 12.5039 21.0044 12.5109 21.0113 12.5164C21.0182 12.5219 21.0262 12.5259 21.0348 12.528C21.049 12.5316 21.0641 12.53 21.0773 12.5234C21.0904 12.5169 21.1008 12.5058 21.1065 12.4923C21.1122 12.4788 21.1128 12.4638 21.1083 12.4498C21.1038 12.4359 21.0944 12.424 21.0818 12.4164Z",
    fill: "#C87100"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4175 9.36004C17.4099 9.35697 17.4018 9.35541 17.3936 9.35547C17.3854 9.35553 17.3773 9.35719 17.3697 9.36036C17.3545 9.36678 17.3424 9.37896 17.3361 9.39424C17.3299 9.40952 17.33 9.42663 17.3365 9.44182C17.3429 9.45701 17.3552 9.46903 17.3705 9.47524C17.3859 9.48145 17.4031 9.48133 17.4183 9.47492C17.4336 9.4685 17.4457 9.45632 17.4519 9.44104C17.4581 9.42576 17.458 9.40865 17.4516 9.39346C17.4451 9.37827 17.4329 9.36625 17.4175 9.36004Z",
    fill: "#C87100"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M20.46 16.3152C19.9246 17.55 19.5665 16.416 19.23 17.7552C18.8936 19.0944 18.1991 18.1908 17.8916 19.3068C17.5841 20.4228 16.933 19.7388 16.6979 20.3148C16.4628 20.8908 16.0649 20.5596 15.9455 20.1564C15.8261 19.7532 15.5222 19.512 14.7807 19.4976C14.0391 19.4832 13.5508 18.7776 13.2542 18.1908C12.9575 17.604 11.6661 17.9784 11.4455 17.496C11.3161 17.2381 11.1232 17.0169 10.8847 16.8532C10.6463 16.6896 10.37 16.5887 10.0817 16.56C9.32932 16.398 8.99653 16.2 8.72522 15.5196C8.45392 14.8392 7.35063 15.2172 7.12635 14.7996C6.90207 14.382 6.99974 13.9716 6.26542 13.8528C5.91624 13.7812 5.59785 13.6039 5.35384 13.3452C5.33575 13.5144 5.42257 13.7052 5.71558 13.8096C6.30882 14.0724 6.345 14.1084 6.69588 14.7312C7.04677 15.354 7.33254 15.2532 7.95111 15.4512C8.56968 15.6492 8.35625 15.7104 8.73969 16.2504C9.12313 16.7904 9.46317 16.7112 9.95874 16.7616C10.4543 16.812 10.6822 16.9956 11.044 17.6472C11.4057 18.2988 11.6227 18.1944 12.2015 18.2556C12.7803 18.3168 12.925 18.4212 13.142 19.0404C13.2352 19.2939 13.4047 19.5126 13.6274 19.6666C13.8501 19.8206 14.1152 19.9024 14.3864 19.9008C14.8639 19.926 15.1099 19.7784 15.3197 20.4696C15.5295 21.1608 16.9186 21.798 17.1284 21.1428C17.3382 20.4876 17.6782 20.61 17.9567 20.448C18.8032 19.9548 18.2063 19.368 18.9153 19.0368C19.7329 18.6768 19.5086 17.892 20.0982 17.5536C20.9772 17.136 20.7819 16.254 21.216 15.9804C21.6501 15.7068 21.9069 15.7392 22.1059 15.3144C21.5054 15.6744 20.8832 15.336 20.46 16.3152Z",
    fill: "url(#paint124_radial_41_893)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0056 29.3333) scale(19.4986 19.405)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#5C5D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F7F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_893",
    x1: 35.7901,
    y1: 3.114,
    x2: 4.93295,
    y2: 28.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#F6F7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CECFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EAE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_41_893",
    x1: 30.5523,
    y1: 8.72641,
    x2: -2.15901,
    y2: 32.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CECFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B6B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_41_893",
    x1: 30.5015,
    y1: 10.7028,
    x2: 3.65086,
    y2: 25.9009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CECFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B6B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_41_893",
    x1: 23.8422,
    y1: 12.7692,
    x2: 10.6002,
    y2: 24.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#CECFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B6B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.61677 28.5388) rotate(-6.1008) scale(11.9235 11.8675)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5C5D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F7F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.69082 28.5731) rotate(-6.1008) scale(9.57406 9.52914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F2BF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E4A35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD8C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DA813A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.42114 27.9432) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.97035 25.4812) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.780538 30.5532) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.265279 33.4514) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.63135 28.3662) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.1899 25.9865) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.90218 30.9425) rotate(-6.10079) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.51238 33.8272) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.43706 28.7276) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.98881 26.3052) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.7164 31.3861) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.24912 34.1908) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1234 29.0567) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6406 26.6831) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.40312 31.7169) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.951 34.3967) rotate(-6.1008) scale(1.06822 1.06321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C28458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF966F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#DBA885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E4B494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9BC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EBBEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBEA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.81439 25.4745) rotate(-6.1008) scale(0.465891 0.463706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.26756 27.868) rotate(-6.10081) scale(0.464227 0.46205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.575526 30.4337) rotate(-6.1008) scale(0.465891 0.463705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.0822767 33.2794) rotate(-6.1008) scale(0.465891 0.463705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.99973 25.8986) rotate(-6.1008) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.45114 28.2922) rotate(-6.1008) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.76047 30.8577) rotate(-6.1008) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.26607 33.7019) rotate(-6.1008) scale(0.465891 0.463706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.77859 26.2644) rotate(-6.10079) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.23066 28.6597) rotate(-6.1008) scale(0.464228 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.53846 31.2252) rotate(-6.1008) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.04363 34.0713) rotate(-6.1008) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.45 26.5784) rotate(-6.1008) scale(0.464227 0.46205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.90179 28.9721) rotate(-6.10079) scale(0.464227 0.462049)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.20953 31.5377) rotate(-6.1008) scale(0.465891 0.463705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.71638 34.3819) rotate(-6.10079) scale(0.464227 0.462048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#340A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#76310C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.19316 24.7856) rotate(-6.1008) scale(3.93511 3.91665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B34313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B74919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C25B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D57747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EF9F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0A170"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.813492 27.8799) rotate(-6.1008) scale(8.21466 8.17612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B34313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B74919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C25B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D57747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EF9F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0A170"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.56741 26.0443) rotate(-6.1008) scale(7.22796 7.19405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B34313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B74919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C25B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D57747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EF9F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0A170"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.74468 31.8661) rotate(-6.1008) scale(7.23629 7.20234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B34313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B74919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C25B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D57747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EF9F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0A170"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6843 23.392) rotate(-6.1008) scale(6.03329 6.00499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B34313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#B74919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C25B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D57747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EF9F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F0A170"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.69072 28.5715) rotate(-6.1008) scale(9.57572 9.5308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F2BF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E4A35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DD8C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DA813A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5036 22.7854) scale(11.9241 11.8669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5C5D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F7F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5851 22.6149) scale(9.57458 9.52862)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFC776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAAD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F5942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F38921"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.402 21.6412) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2138 19.2516) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4849 24.1665) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6628 26.9934) scale(1.06662 1.0615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5485 22.403) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.359 20.0961) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5467 24.8853) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8496 27.7121) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2972 23.0604) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1095 20.7106) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2975 25.6271) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5301 28.3662) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.9349 23.6731) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7017 21.3663) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9332 26.2399) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.194 28.8563) scale(1.06828 1.06315)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D38947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E09D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EAAC79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F1B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F6BE91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F7C094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C094"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0592 19.2284) scale(0.464252 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2569 21.5484) scale(0.464253 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2951 24.0275) scale(0.464253 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4983 26.803) scale(0.465916 0.46368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1789 19.9868) scale(0.464253 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3787 22.3102) scale(0.464253 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4155 24.7876) scale(0.464252 0.462025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6183 27.563) scale(0.464252 0.462023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9012 20.6476) scale(0.464252 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.101 22.9709) scale(0.464252 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1373 25.4484) scale(0.464254 0.462023)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3403 28.2238) scale(0.464253 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5236 21.2421) scale(0.464253 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7235 23.5655) scale(0.464252 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7601 26.0428) scale(0.464252 0.462024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9631 28.8183) scale(0.464254 0.462025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#823400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4969 18.7945) scale(3.93533 3.91644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA4C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D45D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E57934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCA05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA561"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8046 21.512) scale(8.21344 8.17401)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA4C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D45D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E57934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCA05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA561"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7284 20.1939) scale(7.2267 7.19201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA4C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D45D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E57934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCA05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA561"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2742 26.1074) scale(7.23668 7.20195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA4C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D45D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E57934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCA05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA561"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0944 18.2083) scale(6.03362 6.00466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C64600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA4C06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D45D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E57934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCA05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFA561"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.585 22.6133) scale(9.57458 9.52862)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFC776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FAAD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F5942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F38921"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5328 22.6831) rotate(21.8546) scale(12.5447 12.5012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5C5D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F7F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7271 21.7641) rotate(21.8546) scale(10.0737 10.0388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFD976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F4C34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EFAD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EDA327"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.00541 19.5673) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.74041 17.5511) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.11128 21.6751) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.18928 24.1126) rotate(21.8546) scale(1.12244 1.11855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7757 21.5426) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.479 19.6084) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.81643 23.576) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.0179 26.0631) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2011 23.2617) rotate(21.8546) scale(1.12244 1.11855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9214 21.2861) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2088 25.3766) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.37746 27.7504) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5326 24.8932) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1948 22.9423) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5394 27.0074) rotate(21.8546) scale(1.1241 1.12021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7842 29.2727) rotate(21.8546) scale(1.12244 1.11855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CE9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DBAC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E6BA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EEC58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F3CB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4CD97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CD97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.59984 17.468) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.89929 19.4212) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.97998 21.4634) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.10409 23.8625) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3485 19.431) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6454 21.3851) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.72535 23.4287) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.85008 25.8262) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7438 21.1435) rotate(21.8546) scale(0.488884 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0434 23.0968) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1232 25.1405) rotate(21.8546) scale(0.488885 0.487191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.24805 27.5378) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0702 22.7494) rotate(21.8545) scale(0.488885 0.487189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3689 24.7043) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4487 26.748) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5736 29.1454) rotate(21.8546) scale(0.488885 0.48719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A1000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#824500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1507 18.0001) rotate(21.8546) scale(4.14056 4.1262)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C66000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA6606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D47618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E59134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCB55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBA61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.47226 19.2089) rotate(21.8546) scale(8.64195 8.612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C66000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA6606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D47618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E59134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCB55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBA61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8018 19.8484) rotate(21.8546) scale(7.60432 7.57796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C66000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA6606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D47618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E59134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCB55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBA61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.996 25.8357) rotate(21.8546) scale(7.6143 7.5879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C66000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA6606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D47618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E59134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCB55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBA61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8038 20.4019) rotate(21.8546) scale(6.35051 6.3285)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C66000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CA6606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D47618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E59134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCB55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFBA61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_41_893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7272 21.7642) rotate(21.8546) scale(10.0737 10.0388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFD976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F4C34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EFAD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EDA327"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackImage);
export default __webpack_public_path__ + "static/media/snack-image.a52f73890dfdeaafbe54a211e6abbca9.svg";
export { ForwardRef as ReactComponent };